import React from "react";
//import { ResponsiveDatePickers } from "../../component/Elements/Date";
//import { BasicTimePicker } from "../../component/Elements/Timer";
import svgImage from "../../Assets/Images/svgImages";
import paypal from "../../Assets/Images/PayPal 1.png";
import stripe from "../../Assets/Images/Group (1).png";
import { Elements, PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import {
  FormControl,
  Button,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  FormHelperText,
  FormControlLabel,
  styled,
  Grid,
  Checkbox,
  Modal,
  Typography
} from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';

import CheckIcon from "@mui/icons-material/Check";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import { paths } from "../../config/constants";
import BussinessAgentStripePayment from "./bussinessAgentStripePayment";
import { Box } from "@mui/system";
import pakage from "../../Assets/Images/Group (3).png";
import emoji from "../../Assets/Images/g105 (1).png";
import disability1 from "../../Assets/Images/disability.png";
//import ModalFullscreenExample from "../../component/ModelEdit";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useState, useEffect, useRef } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import dayjs from "dayjs";
import Table from "@mui/material/Table";
//import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
//import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { toast } from "react-toastify";
import {
  //StandaloneSearchBox,
  //LoadScript,
  useJsApiLoader,
  Autocomplete,
} from "@react-google-maps/api";
import wallet from "../../Assets/Images/Group (2).png";
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ReceiptLongIcon  from '@mui/icons-material/ReceiptLong';
import AgentSubChild from "./AgentSubChild";
//import { min } from "moment/moment";
//import { maxLength } from "react-admin";
import utc from 'dayjs/plugin/utc';
import "./bussinessBooking.css"
import Scorpio from "../../Assets/Images/Scorpio.jpg"
import user from "../../Assets/Images/user1.png";
import bag from "../../Assets/Images/bag1.png";
import { set } from "date-fns";
dayjs.extend(utc);

//const { GernamySvg } = svgImage;

const AddressFormWrapper = styled("form")({
  fieldset: {
    borderWidth: 0,
  },
  ".content-fields": {
    border: "1px solid #E6E6E6",
    padding: "10px",
  },
  ".MuiOutlinedInput-notchedOutline": {
    borderWidth: "0 !important",
  },
  ".Button": {
    backgroundColor: "#0E4672",
    color: "white",
  },
  ".Button:hover": {
    backgroundColor: "#0E4672",
    color: "white",
  },
  ".css-1ymdq6l-MuiFormLabel-root-MuiInputLabel-root": {
    fontFamily: "DM Sans",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "22px",
    color: "#455E72"
  },
  ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
    fontFamily: "DM Sans",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "20px",
    lineHeight: "27px",
    color: "#1F3648",
    padding: "10px 14px"
  },
})

export default function BussinessBooking() {
  const authget = useSelector((state) => state.login.user);
  const navigate = useNavigate();
  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyBBg22tDfYz76mPhudqsReP2bL9aYjOjsY",
    // libraries:["drawing","places"],
    // libraries: [],
  });
  //const dispatch = useDispatch();
  const reduxdata = useSelector((state) => state);

  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [vehicleData, setVehicleData] = useState([]);
  // let bookingId = reduxdata.homeReducer.bookingId;
  const [fromLocation, setFromLocation] = useState("");
  const [toLocation, setToLocation] = useState("");
  const [isFromLocationSelected, setIsFromLocationSelected] = useState(false);

  const [errorFromLocation, setErrorFromLocation] = useState("");
  const [errorToLocation, setErrorToLocation] = useState("");

  //const [pickDate, setPickDate] = useState(dayjs());

  // const [distance, setDistance] = useState("");
  const [duration, setDuration] = useState("");
//   const [response, setResponse] = useState("");

//   const [show, setShow] = useState(false);
//   const [error, setError] = useState(false);

  const nav = useNavigate();
//   const [timee, setTimee] = useState("");
  // const minDate = dayjs().add(0, 'day');
  const[minDateTime,setMinDateTime]=useState(dayjs.utc());
  const maxDate = dayjs().add(1, 'month');
  const [datee, setDatee] = useState();
  const [returnDate, setReturnDate] = useState();
  // const dateString = datee;
  // const milliseconds = new Date(dateString).getTime();
  // const millisecondsRet = new Date(returnDate).getTime();

  const [bookingId, setBookingId] = useState("");
  const [extraOption, setExtraOption] = useState();
  const [childSeat, setChildSeat] = useState();
  const [childSeatTotal, setChildSeatTotal] = useState(0);
  const [packages, setPackages] = useState();
  const [packagesTotal, setPackagesTotal] = useState(0);
  const [extra, setExtra] = useState("");
  const [extraTotal, setExtraTotal] = useState(0);
  const [journey, setJourney] = React.useState("");
  const [vechicleType, setVehicleType] = React.useState("");
  const [babySeatCount, setBabySeatCount] = useState(0);
  const [childSeatCount, setChildSeatCount] = useState(0);
  const [boosterSeatCount, setBoosterSeatCount] = useState(0);
  const [sliber, setSliber] = useState(0);
  const [gold, setGold] = useState(0);
  const [platinum, setPlatinum] = useState(0);
  const [wheelchair, setWheelchair] = useState(0);
  const [showGeoMaps, setShowGeoMaps] = useState(false);
  const [showGeoMaps2, setShowGeoMaps2] = useState(false);
  const [journeyType, setJourneyType] = useState();
  const [distanceKm, setDistanceKM] = useState();
  const [pickUpDate, setPickupDate] = useState();
  const [duration1, setDuration1] = useState();
  const [route, setRoute] = useState();
  const [fName, setFName] = useState("");
  const [lName, setLName] = useState("");
  const [email, setEmail] = useState("");
  const [numbers, setNumbers] = useState("");
  const [address, setAddress] = useState("");
  const [comment, setComment] = useState("");
  const [fare, setFare] = useState("");
  const [totalFare, setTotalFare] = useState("");
  const [totalReturnFare, setTotalReturnFare] = useState("");
  const [errors, setErrors] = useState({});
  const [errorDetails, setErrorDetails] = useState({});
  const [vahicalInfo, setVahicalInfo] = useState([]);
    const [vehicalCategoryName, setVehicalCategoryName] = useState("");
  // const [globalNumberSum, setGlobalNumberSum] = useState(0); // Store sum in state
  const [taxApplied, setTaxApplied] = useState("");
  const[extraTime,setExtraTime]=useState("0")
  const[returnExtraTime,setReturnExtraTime]=useState("0")
  const[minDatee,setMinDatee]=useState(dayjs());
  const[flightNum,setFlightNum]=useState(0);
  const[returnFlightNum,setReturnFlightNum]=useState(0);
  const[bookingExtraTotal,setBookingExtraTotal]=useState(0);
  const[bookingExtraTaxAm,setBookingExtraTaxAm]=useState(0);
  const[bookingExtraWithoutTax,setBookingExtraWithoutTax]=useState(0);
  const[rideChargesTaxAm,setRideChargesTaxAm]=useState(0);
  const[rideChargesWithoutTax,setRideChargesWithoutTax]=useState(0);
  const[rideCharges,setRideCharges]=useState(0);
  const[Subtotal,setSubTotal]=useState(0)
  const[totalTax,setTotalTax]=useState(0)
  const [checked, setChecked] = useState()
  const role = localStorage.getItem("userRole");
  const accountType = localStorage.getItem("accountType");
  const _userId = localStorage.getItem("_id");
  const employeeCompany=localStorage.getItem("companyName");
  const[employeeCompanyId,setEmployeeCompanyId]=useState(null)
  
  const [priceRuleApplied, setPriceRuleApplied] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyNameError, setCompanyNameError] = useState("");
  const [taxNumber, setTaxNumber] = useState();
  const [taxNumberErrorText, setTaxNumberErrorText] = useState("");
  const [country, setCountry] = useState();
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]); 
  const [city, setCity] = useState("");
  const [stateRegion, setStateRegion] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [postal, setPostal] = useState("");
  const [countryName, setCountryName] = useState("");
  const [stateName, setStateName] = useState("");
  const[passengers,setPassengers]=useState()
  const[returnPassengers,setReturnPassengers]=useState(0)
  const [selectedVehicleCapacity,setSelectedVehicleCapacity]=useState()
  const [commissionPercentage,setCommissionPercentage]=useState(null);
  const roleFName = localStorage.getItem("fname");
  const roleLName = localStorage.getItem("lname");
  // const [fromLocationCoords, setFromLocationCoords] = useState({
  //     lat: reduxdata.homeReducer.fromLat,
  //     lng: reduxdata.homeReducer.fromLong,
  //   });
  // const [toLocationCoords, setToLocationCoords] = useState({
  //     lat: reduxdata.homeReducer.toLat,
  //     lng: reduxdata.homeReducer.toLong,
  //   });
  const [toLocationCoords, setToLocationCoords] = useState("");
  const [fromLocationCoords, setFromLocationCoords] = useState("");
    const [isToLocationSelected, setIsToLocationSelected] = useState(false);
  const [loadingTwo, setLoadingTwo] = useState(true);
  const [vehicleList, setVehicleList] = useState([]);
  const [groupedVehicles, setGroupedVehicles] = useState({});
  const [quoteDialog, setQuoteDialog] = useState(false);
  const [selectedVehicleId, setSelectedVehicleId] = useState(null);
  const [serviceType,setServiceType]=useState("");
  const [selectedChildSeats, setSelectedChildSeats] = useState({});
  const [selectedPackages, setSelectedPackages] = useState({});
  const [selectedExtras, setSelectedExtras] = useState({});
  const [payType, setPayType] = useState("");
  const [showWhiteScreen, setShowWhiteScreen] = useState(false);
  const [paymentCompleted, setPaymentCompleted] = useState(false);
  const [open, setOpen] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);
  const [payCheck,setPayCheck]=useState("")
  const [isCashLoading,setIsCashLoading]=useState(false)
  const [isBankInvoiceLoading,setBankInvoiceLoading]=useState(false)
  const [isCardLoading,setIsCardLoading]=useState(false)
  const toastId = "payment-toast";
  const toastId2 = "flight-toast";
  const toastId3 = "update-toast";
  const toastId4 = "returnFlightNo";
  const toastId5 = "returnDate";
  let toastId6;
  let toastId7;
  const fNameRef = useRef(null);
  const lNameRef = useRef(null);
  const emailRef = useRef(null);
  const phoneRef = useRef(null);
  const stripePromise = loadStripe("pk_test_51Qx8hyLPPTvQPccQvZEBSEuLWAiW4m9AlvQh3tbvbJbRC9Ff5RiNvd1iUJOm5UZLoOg4JNO13BsvL7JUSa2zD5Sy000kfT1HIt");
  const [seatLimitReached, setSeatLimitReached] = useState(false);
  const [localStBookingId,setLocalStBookingId] = useState("")
  const [companyAgentEmail,setCompanyAgentEmail] = useState("")
  const [formData, setFormData] = useState({
      name: "",
      phone: "",
      email: "",
      vehicleCategory: "",
      vehicleCapacity: "",
      luggageCapacity: "",
      pickupAddress: reduxdata.homeReducer.from,
      dropoffAddress: reduxdata.homeReducer.to,
    });
    const [limit,setLimit]=useState(null)
    
  useEffect(()=>{
    setLocalStBookingId(localStorage.getItem("bookingId"))
  },[])
  
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };


  useEffect(() => {
    fetchCountryList();
  }, []);

  const fetchCountryList = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL}api/booking/getCountriesList`
      );
      setCountryList(res?.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  
  useEffect(() => {
    // setCity("");
    if(country !== ""){
      getStateList();
      getCityList();
    }
  }, [country])

  useEffect(() => {
    if(stateRegion!== "")
    {
      getCityList();
    }
  }, [stateRegion])



 const getStateList = async (e) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}api/booking/getStateList`, 
        { countryCode: country }
      );
      setStateList(response?.data?.data);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // Reset the state list if the error is 404
        setStateList([]);
      } else {
        console.log(error);
      }
    }
  };

  const getCityList = async (e) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_URL}api/booking/getCityList`, { countryCode: country, stateName: stateRegion })
      setCityList(response?.data?.result)
    }
    catch (error) {
      if (error.response && error.response.status === 404) {
        setCityList([]);
      } else {
        console.log(error);
      }
    }
  }

 
// Set the priceRuleApplied based on role
// useEffect(() => {
//   if (role == "0") {
//     setPriceRuleApplied("Admin Booking");
//   } else if (role == "4") {
//     setPriceRuleApplied("CS Booking");
//   }
// }, [role]); 

  const [prevServ,setPrevServ]=useState("");

  let toastId1 = null;
  let valid = true;
  let id;
  let booking = "";
  const inputRef = useRef(fromLocation);
  const toRef = useRef(toLocation);
  

  const notify = (val, type = 200) => {
    if (type == 200) {
      toast.success(val);
    } else {
      toast.error(val);
    }
  };

  const handleDateChange = (newDate, placeName) => {
    if (!newDate || !newDate.isValid()) return;
  
    // Use the newDate as local dayjs object (don't convert to utc)
    const validDate = newDate;
  
    // Calculate minDateTime in local time
    let updatedMinDateTime = dayjs();
    if (
      fromLocation.includes("Airport") ||
      fromLocation.includes("Flughafen") ||
      fromLocation.includes("Terminal")
    ) {
      updatedMinDateTime = updatedMinDateTime.add(30, "minute");
    } else {
      updatedMinDateTime = updatedMinDateTime.add(2, "hour");
    }
  
    setMinDateTime(updatedMinDateTime);
    setDatee(validDate);
  };
//////////////////////////////////////////////////////////////////////
console.log("hello")

const handlePlaceChange = () => {
  setShowGeoMaps(false);
  setShowGeoMaps2(false);

  const place = inputRef.current.getPlace();
  
  if (place) {
    const placeName = place.name || place.formatted_address;

    try {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: placeName }, (results, status) => {
        if (status === "OK" && results[0]) {
          const location = results[0].geometry.location;
          const addressComponents = results[0].address_components;

          const country = addressComponents.find(c => c.types.includes("country"));
          const city = addressComponents.find(c => c.types.includes("locality") || c.types.includes("sublocality"));
          const street = addressComponents.find(c => c.types.includes("route"));
          const isAirport = addressComponents.some(c => c.types.includes("airport"));

          if (!country || (!isAirport && (!city || !street))) {
            toast.error("Please enter complete address", { 
              autoClose: 2500,
              toastId: "incomplete-address"
            });

            setFromLocation("");
            setErrorFromLocation("Invalid location");
            setIsFromLocationSelected(false);
            return;
          }

          // If address is complete
          setFromLocation(placeName);
          setIsFromLocationSelected(true);

          setFromLocationCoords({
            lat: location.lat(),
            lng: location.lng(),
          });

          setErrorFromLocation("");

          // Set time logic
          if (
            placeName.includes("Airport") ||
            placeName.includes("Flughafen") ||
            placeName.includes("Terminal")
          ) {
            setMinDateTime(dayjs().add(30, "minutes"));
          } else {
            setMinDateTime(dayjs().add(2, "hours"));
          }

        } else {
          console.error("Geocoding failed:", status);
        }
      });
    } catch (error) {
      console.error("Error in geocoding:", error);
    }
  }
};



const handlePlaceToChange = () => {
  setShowGeoMaps(false);
  setShowGeoMaps2(false);
  
  // Use toRef to get the place
  const toPlace = toRef.current?.getPlace(); // <-- Use `toRef` here
  
  if (!toPlace) {
    console.error("Place is undefined or not available");
    return;
  }
  
  const placeName = toPlace.name || toPlace.formatted_address;
  
  // Prevent selecting same as pickup
  if (placeName === fromLocation) {
    toast.error("Pickup and Destination Location cannot be the same", { 
      autoClose: 2500,
      toastId: "same-pick-drop"
    });
    setToLocation("");
    setIsToLocationSelected(false);
    return;
  }
  
  // Geocode
  const geocoder = new window.google.maps.Geocoder();
  geocoder.geocode({ address: placeName }, (results, status) => {
    if (status === "OK" && results[0]) {
      const location = results[0].geometry.location;
  
      // Extract address components
      const addressComponents = results[0].address_components;
      const country = addressComponents.find(c => c.types.includes("country"));
      const city = addressComponents.find(c => c.types.includes("locality") || c.types.includes("sublocality"));
      const street = addressComponents.find(c => c.types.includes("route"));
      const isAirport = addressComponents.some(c => c.types.includes("airport"));
  
      if (!country || (!isAirport && (!city || !street))) {
        toast.error("Please enter complete address", { 
          autoClose: 2500,
          toastId: "incomplete-destination"
        });
  
        setToLocation("");
        setErrorToLocation("Invalid location");
        setIsToLocationSelected(false);
        return;
      }
  
      // If address is complete:
      setToLocation(placeName);
      setIsToLocationSelected(true);
  
      setToLocationCoords({
        lat: location.lat(),
        lng: location.lng(),
      });
  
      setErrorToLocation("");
    }
  });
};





useEffect(()=>{
  console.log("fromTo",fromLocationCoords,"   ", toLocationCoords)
},[fromLocationCoords,toLocationCoords])

  const fetchAllVehicleData = () => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_URL}api/vehicalType/getAllVehicalList`)
      .then(function (res) {
        setVehicleData(res.data.res || []);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchAllVehicleData();
  }, []);

  const handleDuration = (callback) => {
    const directionsService = new window.google.maps.DirectionsService();
    const pickupInput = fromLocation;
    const dropoffInput = toLocation;
  
    if (!pickupInput || !dropoffInput) {
      alert("Both pickup and dropoff locations are required.");
      return;
    }
  
    const request = {
      origin: pickupInput,
      destination: dropoffInput,
      optimizeWaypoints: false,
      provideRouteAlternatives: true,
      travelMode: window.google.maps.TravelMode.DRIVING,
    };
  
    directionsService.route(request, (response, status) => {
      if (status === window.google.maps.DirectionsStatus.OK) {
        let shortestRoute = response.routes[0];
        let shortestDistance = shortestRoute.legs.reduce(
          (total, leg) => total + leg.distance.value,
          0
        );
  
        response.routes.forEach((route) => {
          const distance = route.legs.reduce(
            (total, leg) => total + leg.distance.value,
            0
          );
          if (distance < shortestDistance) {
            shortestRoute = route;
            shortestDistance = distance;
          }
        });
  
        const shortestDuration = shortestRoute.legs.reduce(
          (total, leg) => total + leg.duration.value,
          0
        );
  
        const formattedDistance = Math.ceil(shortestDistance / 1000)
          .toString();
        const totalMinutes = Math.floor(shortestDuration / 60);
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
  
        const formattedDuration = `${hours} hours and ${minutes} mins`;
  
        callback(formattedDistance, formattedDuration);
        if (window.directionsRenderer && window.finaldirectionsRenderer) {
          const modifiedResponse = { ...response, routes: [shortestRoute] };
          window.directionsRenderer.setDirections(modifiedResponse);
          window.finaldirectionsRenderer.setDirections(modifiedResponse);
        } else {
          console.error("Directions renderer is not initialized.");
        }
      } else {
        console.error("Error calculating route:", status);
      }
    });
  };
  
  const handleFinal = async (bookId) => {
    const data = {
      userId: reduxdata?.login?.user?.data?._id,
      bookingId: bookId,
      fromLocation: fromLocationCoords,
      toLocation: toLocationCoords,
    };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/user/userLatLng`,
        data
      );

      if (res?.data?.status === 200) {
        console.log("LatLng Stored successfully")
      }
    } catch (error) {
      // Handle error
    }
  };

  const handleHomepage = async (e) => {
    e.preventDefault();
    let newErrors = {}
    if (!datee) { newErrors.datee = "Please enter Source" };
    if (fromLocation===toLocation){
      newErrors.fromLocation = "Pick and Drop-off cant be same"
      newErrors.toLocation = "Pick and Drop-off cant be same"
    }
    if (!journey) { newErrors.journey = "Please select journy type" }
    if (!fromLocation) { newErrors.fromLocation = "Please enter Source" }
    if (!toLocation) { newErrors.toLocation = "Please enter Destination" }
    if (!returnDate && journey === "Return") {newErrors.returnDate = "Please enter Return Date" }
    if (Object.keys(newErrors).length === 0) {
      handleDuration((distance, duration) => {
        // setTimeout(() => {
        // handleClick(distance, duration); 
        setPickupDate(datee ? dayjs(datee).format("DD/MM/YYYY HH:mm") : "")
        handleCars(distance,duration)
        // }, 5000);
      });
    }
    setErrors(newErrors);
  };
useEffect(()=>{
// if (role=="2.1"){
//   const fetchUser = async () => {
//   try {
//     const res = await axios.post("http://localhost:5000/api/get-user-by-company", {
//       companyName: "Tesla Inc",
//       accountType: "AGENT"
//     });

//     console.log("User found:", res.data.data);
//   } catch (err) {
//     console.error("Error fetching user:", err.response?.data || err.message);
//   }
// };
// }
const fetchUser = async () => {
  try {
    const res = await axios.post("http://localhost:5000/api/get-user-by-company", {
      companyName: companyName,
      accountType: "Company"
    });

    console.log("User found:", res.data.data);
  } catch (err) {
    console.error("Error fetching user:", err.response?.data || err.message);
  }
};
},[])
  
const addBussinessAgentExtraServices=async(bussinessBookingId,check,status)=>{
  let data = {
        bookingId: bussinessBookingId,
        childSeat:selectedChildSeats,
        packages:selectedPackages,
        extras:selectedExtras,
        //number: count,
        //action: val,
      };
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_URL}api/booking/addBussinessAgentExtraServices`,
          data
        );
        console.log("resadd",res)
        if (res?.data?.status === 200) {
          console.log("i came here")
          handleSubmit(bussinessBookingId,check,status)
        }
      } catch (error) {
        setIsCashLoading(false)
        setBankInvoiceLoading(false)
        setIsCardLoading(false)
        if (!toast.isActive(toastId7)) {
          toastId7 = toast.error(
          "Booking Failed.",
          { autoClose: 2500 }
          );
        }

        console.log(error);
      }
}

const updateBussinessAgentExtraServices=async(updatedFare,check)=>{
  let data = {
        bookingId: bookingId,
        childSeat:selectedChildSeats,
        packages:selectedPackages,
        extras:selectedExtras,
        //number: count,
        //action: val,
      };
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_URL}api/booking/updateBussinessAgentExtraServices`,
          data
        );
        console.log("resadd",res)
        if (res?.data?.status === 200) {
          console.log("i came here")
          
          if(check=="card"){
            console.log("PayCheck",payCheck)
            handleOpen(updatedFare)
          }
          else if (check=="Cash" ||check=="Bank Invoice"){
            navigate(paths.company.dashboard);
          }
        }
      } catch (error) {
        setIsCashLoading(false)
        setBankInvoiceLoading(false)
        setIsCardLoading(false)
        if (!toast.isActive(toastId7)) {
          toastId7 = toast.error(
          "Booking Failed.",
          { autoClose: 2500 }
          );
        }
        console.log(error);
      }
}

   const handleClick2 = async (check,status) => {
    const distance = distanceKm
    const duration = duration1
    let updatedFare;
    if (journey == "Return") {
      updatedFare = totalFare * 2;
    }
    else{
      updatedFare=totalFare
    }
    const data = {
        toLocation:toLocation,
        fromLocation:fromLocation,
        date: new Date(datee).getTime(),
        returnDate: new Date(returnDate).getTime(),
        bookingType:journey,
        distance:distance,
        time:duration,
        vehicalTypeId:selectedVehicleId,
        serviceType:serviceType,
        bookingId:bookingId,
        returnFlightNumber:returnFlightNum,
        returnExtraTime:returnExtraTime,
        returnPassanger:returnPassengers,
        returnTime:duration,
        returnDistance:distance,
        returnFromLocation:toLocation,
        returntoLocation:fromLocation,
        flightNumber:flightNum,
        passanger:passengers,
        extraTime:extraTime,
        taxPercentage:taxApplied,
        subTotal:Subtotal,
        priceRuleApplied : priceRuleApplied,
        price:rideChargesWithoutTax,
        bookingExtraTotal:bookingExtraTotal,
        tax:totalTax,
        total:updatedFare,
        paymentType: check,
        failStatus:status,
        comingFrom:accountType,
        customerEmail:email,
        
    }
    try {
        const res = await axios.put(
          `${process.env.REACT_APP_URL}api/booking/companyAgentEditBooking`,
          data
        );
        if (res?.status === 200) {
          setLoading(false);
          notify(res.msg, res.status);
          updateBussinessAgentExtraServices(updatedFare,check)
        }
      } catch (error) {
        setIsCashLoading(false)
        setBankInvoiceLoading(false)
        setIsCardLoading(false)
        if (!toast.isActive(toastId7)) {
          toastId7 = toast.error(
          "Booking Failed.",
          { autoClose: 2500 }
          );
        }
        notify(error.response.data.msg, error.response.data.status);
        setLoading(false);
      }
  };

const addcontactDetails=async(check,status)=>{
      console.log("Heon")
    let data = {
      bookingId: bookingId,
      fName: fName,
      lName:lName,
      email: email,
      phoneNumber: numbers,
      companyName:companyName,
      taxNumber:taxNumber,
      city:city,
      stateRegion:stateRegion,
      country:country,
      countryName:countryName,
      stateName:stateName,
      houseNumber:address1,
      street:address2,
      postalCode:postal,
      typeAnything: comment,
      billingAddressCheck: checked,
      passanger:passengers,
      returnPassanger:returnPassengers
    };
    let newErrorDetails = {};
    if (!fName) {
      newErrorDetails.fName = "Please enter First name";
    }
    if (!lName) {
      newErrorDetails.lName = "Please enter Last name";
    }
    if (!email) {
      newErrorDetails.email = "Please enter email";
    }
    if (!numbers) {
      newErrorDetails.numbers = "Please enter mobile number";
    }
    if (checked && companyName === "") {
      newErrorDetails.companyName = "Please enter Company Name"
    } 
    if(checked && companyName.length<2){
      newErrorDetails.companyName = "Please enter valid Company Name"};
    if(checked && companyName.length>100){
        newErrorDetails.companyName = "Company Name cannot exceed 100 letters"
      }
    if (Object.keys(newErrorDetails).length === 0) {
      setLoading(true);
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_URL}api/booking/addContactDetails`,
          data
        );
        if (res?.status === 200) {
          notify(res.msg, res.status);
          handleClick2(check,status);
        }
      } catch (error) {
        setIsCashLoading(false)
        setBankInvoiceLoading(false)
        setIsCardLoading(false)
        if (!toast.isActive(toastId7)) {
          toastId7 = toast.error(
          "Booking Failed.",
          { autoClose: 2500 }
          );
        }
        notify(error.response.data.msg, error.response.data.status);
        setLoading(false);
      }
    
    setErrorDetails(newErrorDetails);
    }
  };

  const handleClick = async (check,status) => {
    
    let data;

    const milliseconds = datee ? dayjs.utc(datee.format('YYYY-MM-DD HH:mm')).valueOf() : null;
  
    let millisecondsRet = returnDate ? dayjs.utc(returnDate.format('YYYY-MM-DD HH:mm')).valueOf() : null;
    let uID;
    let employeeId=null
    if (role=="2.1"){
      console.log("Employee hu yr")
      uID=employeeCompanyId;
      employeeId=_userId
    }
    else{
      console.log("company iD")
      uID=_userId;
    }
   data = {
      userId: uID,
      employeeId:employeeId,
      bookingId: bookingId || "",
      fromLocation,
      toLocation,
      date: milliseconds,
      bookingType: journey,
      distance:distanceKm,
      time: duration1,
      vehicalCategoryName: vehicalCategoryName,
      //vehicalTypeId: vechicleType,
      returnDate: millisecondsRet,
      taxPercentage: taxApplied,
      extraTime,
      returnExtraTime,
      passanger:passengers,
      returnPassanger:returnPassengers
    };
    console.log("data",data)
    let newErrorDetails = {};
    if (!fName) { newErrorDetails.fName = "Please enter first name" };
    if (!lName) { newErrorDetails.lName = "Please enter last name" };
    if (!email) { newErrorDetails.email = "Please enter email" };
    if (!numbers) { newErrorDetails.numbers = "Please enter mobile number" };
    if (checked && companyName === "") {
      newErrorDetails.companyName = "Please enter Company Name"
    } 
    if(checked && companyName.length<2){
      newErrorDetails.companyName = "Please enter valid Company Name"};
    if(checked && companyName.length>100){
        newErrorDetails.companyName = "Company Name cannot exceed 100 letters"
      }
    // else {
    //   setCompanyNameError("");
    // }
    if (Object.keys(newErrorDetails).length === 0) {
    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/booking/phoneBooking`,
        data
      );
      if (res?.status === 200) {
        setLoading(false);
        notify(res.msg, res.status);
        //setShowGeoMaps(true);
        setBookingId(res?.data?.data?._id);
        localStorage.setItem("bookingId",res?.data?.data?._id)
        //handleVehicalInfo(res?.data?.data?._id);
        addBussinessAgentExtraServices(res?.data?.data?._id,check,status)
        //setPickupDate(dayjs.utc(res?.data?.data?.date).format('DD/MM/YYYY HH:mm'));
      }
    } catch (error) {
      setIsCashLoading(false)
      setBankInvoiceLoading(false)
      setIsCardLoading(false)
      if (!toast.isActive(toastId7)) {
          toastId7 = toast.error(
          "Booking Failed",
          { autoClose: 2500 }
          );
        }
      notify(error.response.data.msg, error.response.data.status);
      setLoading(false);
    }
    }
        setErrorDetails(newErrorDetails);
        setIsCashLoading(false)
        setBankInvoiceLoading(false)
        setIsCardLoading(false)


    
    
    
  };
  

  useEffect(()=>{
    fetchAllChildSeat();
    fetchAllExtra();
    fetchAllPackage();
  },[taxApplied])

  useEffect(() => {
    setBooking();
  }, []);
  const setBooking = (booking) => {
    setBookingId(booking);
  };

  const handleVehicalInfo = async (id1) => {
    let data = {
      bookingId: id1,
    };
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/booking/getBookedVehicalInfo`,
        data
      );
      if (res.status === 200) { 
        setVahicalInfo(res?.data?.vehicalInfo);
      }
    } catch (error) { }
  };

  const fetchAllChildSeat = () => {
    setLoading(true);
    let totall=0;
    axios
    .post(`${process.env.REACT_APP_URL}api/extraOption/getExtraOptionListBusinessAgent`, {
      category: "CHILD_SEAT",
      bookingId: bookingId,
      Tax:taxApplied
      
    })
    .then(function (res) {
      const sum = res?.data.data.reduce((total, item) => {
        if (item.flag === "1") {
          totall=totall+(item.number*item.price)
          return total + item.number;
        }
        return total;
      }, 0);
      //setGlobalNumberSum(sum);
      //setChildSeatTotal(totall);
      setChildSeat(res?.data?.data || []);
      setLoading(false);
    })
    .catch(function (error) {
      console.log(error);
      setLoading(false);
    });
    
  };



const fetchAllPackage = async (id) => { 
let extraObj = {
  category: "PACKAGE",
  bookingId: bookingId , 
  Tax:taxApplied
};
let totall3=0;
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/extraOption/getExtraOptionListBusinessAgent`,
        extraObj
      );
      res?.data.data.find((item) => {
        if (item.flag == "1") {
          totall3=item.price
        }
    })
    //setPackagesTotal(totall3)
      setPackages(res?.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchAllExtra = () => {
    setLoading(true);
    let totall2=0;
    axios
      .post(`${process.env.REACT_APP_URL}api/extraOption/getExtraOptionListBusinessAgent`, {
        category: "EXTRA",
        bookingId: bookingId,
        Tax:taxApplied
      })
      .then(function (res) {
        const sum = res?.data.data.reduce((total, item) => {
          if (item.flag === "1") {
            totall2=totall2+item.price
          }
      })
        setExtraTotal(totall2)
        setExtra(res?.data?.data || []);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
    
  };
  const discardBooking=async()=>{
    const data = {
      _id:localStBookingId,
      failStatus:"Failed",
      discardedBy: `Discarded by ${roleFName} ${roleLName}`}
  try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/booking/updateRideStatusAndPaymentType`,
        data
      );
      if (res?.status === 200) {
        //notify(res.msg, res.status);
      }
    } catch (error) {
      //notify(error.response.data.msg, error.response.data.status);
      setLoading(false);
    }
  };
  const handleSubmit = async (bussinessBookingId,check,status) => {
    let updatedFare = totalFare;
    let commissionAmount= totalFare*(commissionPercentage/100)
    if (journey == "Return") {
      updatedFare = totalFare * 2;
    }
    let failStatus;
    if(status=="Failed"){
      failStatus="Failed"
    }
    else{
      failStatus=""
    }
    let data;
    if(role=="2.1" && accountType=="Employee"){
      data = {
      bookingId: bussinessBookingId,
      fName: fName,
      lName:lName,
      email: email,
      phoneNumber: numbers,
      fullAddress: address,
      comment: comment,
      bookingExtraTotal:bookingExtraTotal,
      price: rideChargesWithoutTax,
      paymentType: check,
      priceRuleApplied : priceRuleApplied,
      subTotal:Subtotal,
      tax:totalTax,
      flightNumber:flightNum,
      returnFlightNumber:returnFlightNum,
      total:updatedFare,
      companyName:companyName,
      taxNumber:taxNumber,
      city:city,
      stateRegion:stateRegion,
      country:country,
      countryName:countryName,
      stateName:stateName,
      houseNumber:address1,
      street:address2,
      postalCode:postal,
      billingAddressCheck: checked,
      vehicalTypeId: selectedVehicleId,
      serviceType:serviceType,
      bussinessBookingBy:accountType,
      employeeID:_userId,
      passengers:passengers,
      returnPassengers:returnPassengers,
      failStatus:failStatus,
      commissionPercentage:commissionPercentage,
      commissionAmount:commissionAmount
    };
    }
    else{
      data = {
      bookingId: bussinessBookingId,
      fName: fName,
      lName:lName,
      email: email,
      phoneNumber: numbers,
      fullAddress: address,
      comment: comment,
      bookingExtraTotal:bookingExtraTotal,
      price: rideChargesWithoutTax,
      paymentType: check,
      priceRuleApplied : priceRuleApplied,
      subTotal:Subtotal,
      tax:totalTax,
      flightNumber:flightNum,
      returnFlightNumber:returnFlightNum,
      total:updatedFare,
      companyName:companyName,
      taxNumber:taxNumber,
      city:city,
      stateRegion:stateRegion,
      country:country,
      countryName:countryName,
      stateName:stateName,
      houseNumber:address1,
      street:address2,
      postalCode:postal,
      billingAddressCheck: checked,
      vehicalTypeId: selectedVehicleId,
      serviceType:serviceType,
      bussinessBookingBy:accountType,
      passengers:passengers,
      returnPassengers:returnPassengers,
      failStatus:failStatus,
      companyAgentEmail:companyAgentEmail,
      commissionPercentage:commissionPercentage,
      commissionAmount:commissionAmount
    };
    }
      setLoading(true);
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_URL}api/booking/addInfoAndExtraOption`,
          data
        );
        if (res?.status === 200) {
            console.log("Ones",payCheck,check)

          //setLoading(false);
          //notify(res.msg, res.status);
          if(check=="Card"){
            console.log("PayCheck",payCheck)
            handleOpen(updatedFare)
          }
          else if (check=="Cash"||check=="Bank Invoice"){
              console.log("Oness",payCheck,check,accountType)

            if(role=="2" && accountType=="Company"){
              navigate(paths.company.dashboard);
            }
            else if(role=="2" && accountType=="Agent"){
              navigate(paths.businessAgent.dashboard);
            }
            else if(role=="2.1"){
              navigate(paths.employeeRideDetails);
            }
            
          }
          //navigate(paths.company.dashboard);
        }
      } catch (error) {
        setIsCashLoading(false)
        setBankInvoiceLoading(false)
        setIsCardLoading(false)
        if (!toast.isActive(toastId7)) {
          toastId7 = toast.error(
          "Booking Failed.",
          { autoClose: 2500 }
          );
        }
        notify(error.response.data.msg, error.response.data.status);
        setLoading(false);
      } 
  };

  const handleJourney = (event) => {
    setShowGeoMaps(false)
    setShowGeoMaps2(false)
    setJourney(event.target.value);
  };
  // const handleVehicleType = (event) => {
  //   setShowGeoMaps(false);
  //   setVehicleType(event.target.value);
  //   const matchedVehicle = vehicleData.find(
  //     (vehicle) => vehicle._id === event.target.value
  //   );
  
  //   setSelectedVehicleCapacity(matchedVehicle?.passengersNumber);
  //   setPassengers("")
  //   setReturnPassengers("")
  //   };
 
  const handleBabySeatIncrement = () => {
    setBabySeatCount((prevCount) => prevCount + 1);
  };

  const handleBabySeatDecrement = () => {
    if (babySeatCount > 1) {
      setBabySeatCount(babySeatCount - 1);
    }
  };
  const maxChildSeats = passengers - 1;

  const globalNumberSum = Object.values(selectedChildSeats).reduce(
  (sum, item) => sum + item.count,
  0
);
const isMaxReached = globalNumberSum >= (passengers - 1);
  const handleSelect = async (serviceId, val, count, price) => {

  if (!serviceId || typeof count !== "number" || count < 0) return;

  if (globalNumberSum > maxChildSeats && val === 1) {
    if (!toast.isActive(toastId1)) {
      toastId1 = toast.error(
        "Can't add more than vehicle seat capacity. One seat is reserved for adult."
      );
    }
    return;
  }

  setSelectedChildSeats(prev => {
    const updated = { ...prev };
    if (count === 0) {
      delete updated[serviceId];
    } else {
      updated[serviceId] = { count, price };
    }
    return updated;
  });  
  };

  const totalChildSeatPrice = Object.values(selectedChildSeats).reduce(
  (sum, item) => sum + item.count * item.price,
  0
);

useEffect(()=>{
    setSelectedChildSeats({})
    setSelectedPackages({})
    setSelectedExtras({})
    console.log("childSeatCounts Cap",passengers)

  },[passengers])
  
  useEffect(()=>{
    console.log("childSeatCounts",selectedChildSeats)
    console.log("childSeatCounts total",totalChildSeatPrice)
    setChildSeatTotal(totalChildSeatPrice)
  },[selectedChildSeats])
 

  const handleSelectService = (serviceId, action, price) => {
  setSelectedPackages(prev => {
    if (action === 1) {
      // Select only this one, clear others
      return { [serviceId]: price };
    } else {
      // Unselect everything (reset object)
      return {};
    }
  });
};
 

  const totalPackagePrice = Object.values(selectedPackages).reduce(
  (sum, price) => sum + price,
  0
  );

   useEffect(()=>{
    console.log("setSelectedPackages", selectedPackages)
    console.log("setSelectedPackages Total", totalPackagePrice)
    setPackagesTotal(totalPackagePrice)
    
  },[selectedPackages])


  const handleExtraService = async (service_id, action, price) => {

    setSelectedExtras(prev => {
    const updated = { ...prev };

    if (action === 1) {
      updated[service_id] = price; // ✅ Select
    } else {
      delete updated[service_id]; // ❌ Unselect
    }

    return updated;
  });


    // let data = {
    //   bookingId: bookingId,
    //   serviceId: service_id,
    //   number: "",
    //   action: val,
    // };
    // try {
    //   const res = await axios.post(
    //     `${process.env.REACT_APP_URL}api/booking/addExtraServices`,
    //     data
    //   );
    //   if (res?.data?.status === 200) {
    //     fetchAllExtra();
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
  };

  const totalExtrasPrice = Object.values(selectedExtras).reduce(
  (sum, price) => sum + price,
  0
);

useEffect(()=>{
  console.log("selectedExtras",selectedExtras)
  console.log("selectedExtras total",totalExtrasPrice)
  setExtraTotal(totalExtrasPrice)
},[selectedExtras])


  //   const handleChildSeatIncrement = () => {
  //     setChildSeatCount((prevCount) => prevCount + 1);
  //   };

  //   const handleChildSeatDecrement = () => {
  //     if (childSeatCount > 0) {
  //       setChildSeatCount((prevCount) => prevCount - 1);
  //     }
  //   };

  //   const handleBoosterSeatIncrement = () => {
  //     setBoosterSeatCount((prevCount) => prevCount + 1);
  //   };

  //   const handleBoosterSeatDecrement = () => {
  //     if (boosterSeatCount > 0) {
  //       setBoosterSeatCount((prevCount) => prevCount - 1);
  //     }
  //   };
  const handleSliberIncrement = () => {
    setSliber((prevCount) => prevCount + 1);
  };

  const handleSliberDecrement = () => {
    if (sliber > 0) {
      setSliber((prevCount) => prevCount - 1);
    }
  };
  const handleGoldIncrement = () => {
    setGold((prevCount) => prevCount + 1);
  };

  const handleGoldDecrement = () => {
    if (gold > 0) {
      setGold((prevCount) => prevCount - 1);
    }
  };
  const handlePlatinumIncrement = () => {
    setPlatinum((prevCount) => prevCount + 1);
  };

  const handlePlatinumDecrement = () => {
    if (platinum > 0) {
      setPlatinum((prevCount) => prevCount - 1);
    }
  };
  const handleWheelChairIncrement = () => {
    setWheelchair((prevCount) => prevCount + 1);
  };

  const handleWheelChairDecrement = () => {
    if (wheelchair > 0) {
      setWheelchair((prevCount) => prevCount - 1);
    }
  };

   useEffect(() => {
      const parseTravelTime = (timeString) => {
        if (!timeString) return 0;  
        const match = timeString.match(/(\d+)\s*hours?\s*(?:and\s*)?(\d+)?\s*mins?/);
        const hours = match && match[1] ? parseInt(match[1]) : 0;
        const minutes = match && match[2] ? parseInt(match[2]) : 0;
        return hours * 60 + minutes; 
      };
    
      const parseExtraTime = (extraTimeString) => {
        const match = extraTimeString.match(/(\d+)\s*(hours?|min)/);
        const value = match && match[1] ? parseInt(match[1]) : 0;
        if (match && match[2] === "hours") {
          return value * 60; 
        }
        return value; 
      };
    
      const pickDateTime = dayjs(datee);
      const travelMinutes = parseTravelTime(duration1);
      const extraMinutes = parseExtraTime(extraTime);
      const minDates = pickDateTime.add(travelMinutes + extraMinutes, "minute");
      setMinDatee(dayjs(minDates));
    }, [datee, duration1, extraTime]);
    
    const minDateTimes = dayjs(minDatee).minute(minDatee.minute()).second(minDatee.second());
    useEffect(()=>{
      if(journey=="One Way"){
        setReturnDate(null)
        setReturnExtraTime("");
      }
    },[journey])
    useEffect(()=>{
      setBookingExtraTotal(childSeatTotal+packagesTotal+extraTotal)
    },[childSeatTotal,packagesTotal,extraTotal])
    useEffect(()=>{
      let temp=0;
      temp=bookingExtraTotal/(1+(taxApplied/100))
      setBookingExtraWithoutTax((temp).toFixed(2))
      setBookingExtraTaxAm((bookingExtraTotal-temp).toFixed(2))
    },[bookingExtraTotal,taxApplied])
    useEffect(() => {
      if (!fare) {
        setRideChargesWithoutTax(0);
        setRideChargesTaxAm(0);
      } else {
        // const updatedRideCharges = fare - bookingExtraTotal;
        const updatedRideCharges = fare;
    
        const updatedRideChargesWithoutTax = updatedRideCharges / (1 + taxApplied / 100);
    
        const updatedRideChargesTaxAm = updatedRideCharges - updatedRideChargesWithoutTax;
        setRideCharges(updatedRideCharges);
        setRideChargesWithoutTax(updatedRideChargesWithoutTax.toFixed(2)); 
        setRideChargesTaxAm(updatedRideChargesTaxAm.toFixed(2)); 
      } 
    }, [fare, bookingExtraTotal, taxApplied]);

    useEffect(() => {
      let temp = parseFloat(rideChargesWithoutTax) + parseFloat(bookingExtraWithoutTax);
      setSubTotal(parseFloat(temp.toFixed(2))); 
    }, [rideChargesWithoutTax, bookingExtraWithoutTax]);
    useEffect(()=>{
      let temp1;
      temp1=parseFloat(bookingExtraTaxAm)+parseFloat(rideChargesTaxAm)
      setTotalTax(parseFloat(temp1.toFixed(2)))

    },[bookingExtraTaxAm,rideChargesTaxAm])

  // const minDate = dayjs().add(0, 'day');
  // const maxDate = dayjs().add(1, 'month');
  useEffect(() => {
    if(!checked){
      setCompanyName("");
      setTaxNumber("");
      setCountry("");
      setStateRegion("");
      setCountryName("");
      setStateName("");
      setAddress1("");
      setAddress2("");
      setCity("")
      setPostal("")
    }
  }, [checked]);

const handleCars = async(distance,duration) => {
    setShowGeoMaps2(true)
    fetchData(distance,duration)

  }
  const fetchData = async (distance,duration) => { 
      setLoading(true); 
      setLoadingTwo(true);
      setJourneyType(journey);
      setDistanceKM(distance);
      setDuration1(duration);
      setRoute(`${fromLocation} to ${toLocation}`);  
      //setPickupDate(dayjs.utc(datee).format('DD/MM/YYYY HH:mm'));
    
      const data = {
        fromLocation:fromLocation,
        toLocation:toLocation,
        distance:distance,
        fromLocationCoords: fromLocationCoords,
        toLocationCoords: toLocationCoords,
    };
    
      try {
        // Only include the getExtraClass API call if bookingId is not empty
        const promises = [axios.post(`${process.env.REACT_APP_URL}api/admin/setCompanyAgentPrice`,data)];
        promises.push(axios.get(`${process.env.REACT_APP_URL}api/admin/getExtraClass`));

        
        const [setPriceResponse, extraClassResponse] = await Promise.allSettled(promises);
        if (setPriceResponse?.status === 'fulfilled' && setPriceResponse?.value?.status === 200) {
          const vehiclesList = setPriceResponse?.value?.data?.result || [];
          setPriceRuleApplied(setPriceResponse?.value?.data?.condition)
          let extraClassList = [];
          if (extraClassResponse?.status === 'fulfilled' && extraClassResponse?.value?.status === 200) {
            extraClassList = extraClassResponse?.value?.data?.res || [];
          }
          if (extraClassList.length === 0) {
            console.log("No extra class data found. Check the API or data source.");
          }
          const combinedData = [...vehiclesList, ...extraClassList];
          setVehicleList(combinedData);
        } else {
          console.log("One of the APIs failed");
          setLoading2(false);
          setLoadingTwo(false);
        }
      } catch (error) {
        console.error("Error occurred while fetching data:", error);
        setLoading2(false);
        setLoadingTwo(false);
      } finally {
        setLoading2(false);
        setLoadingTwo(false);
      }
    };

      useEffect(() => {
        if (vehicleList) {
          const grouped = (vehicleList || []).reduce((acc, vehicle) => {
            const vehicleClassDetail = vehicle.vehicleClassDetail;
    
            if (!vehicleClassDetail) {
              console.error("Missing vehicleClassDetail for vehicle:", vehicle);
            }
    
            const vehicleClass = vehicleClassDetail
              ? vehicleClassDetail.vehicleClass
              : "Unknown";
    
            if (!acc[vehicleClass]) {
              acc[vehicleClass] = [];
            }
    
            acc[vehicleClass].push(vehicle);
            return acc;
          }, {});
    
          const sortedGrouped = Object.keys(grouped).reduce((acc, key) => {
            acc[key] = grouped[key].sort((a, b) => {
              const priorityA = a.vehicleClassDetail?.priority ?? 0; 
              const priorityB = b.vehicleClassDetail?.priority ?? 0;
    
              return priorityA - priorityB;
            });
            return acc;
          }, {});
    
          const sortedGroupKeys = Object.keys(sortedGrouped).sort((a, b) => {
            const minPriorityA = Math.min(
              ...sortedGrouped[a].map(
                (item) => item.vehicleClassDetail?.priority ?? 0
              )
            );
            const minPriorityB = Math.min(
              ...sortedGrouped[b].map(
                (item) => item.vehicleClassDetail?.priority ?? 0
              )
            );
    
            return minPriorityA - minPriorityB;
          });
          const finalSortedGrouped = sortedGroupKeys.reduce((acc, key) => {
            acc[key] = sortedGrouped[key];
            return acc;
          }, {});
    
          console.log(finalSortedGrouped);
    
          console.log("Sorted Grouped Vehicles:", finalSortedGrouped);
          setGroupedVehicles(finalSortedGrouped);
        }
      }, [vehicleList]);

      const handleSend = async (vehicleId, price,taxPercent) => {
          const data = {
            vehicalTypeId: vehicleId,
            bookingId: id,
            price: price,
            taxPercentage:taxPercent
          };

          // try {
          //   const res = await axios.post(
          //     `${process.env.REACT_APP_URL}api/booking/addBooking`,
          //     data
          //   );
          //   console.log(res?.data);
          //   if (res?.data?.status === 200) {
          //     setValidates(true);
          //     navigate("/contact", { state: { taxPercentage: taxPercent } }); // ✅ Pass taxPercent in state
          //   }
          // } catch (error) {
          //   // Handle error
          // }
        };


      const handleCarSelect = async (currentValue) => {
        console.log("currentValueHS",currentValue)
        setPassengers(parseFloat(currentValue?.passengersNumber))
        setVehicalCategoryName(currentValue?.vehicalStandard)
        setFare(currentValue?.price)
        if(journey=="Return"){
        setReturnPassengers(parseFloat(currentValue?.passengersNumber));
        }
        else{
          setReturnPassengers(0)
        }
        setShowGeoMaps(true)

      };

      useEffect(()=>{
          if (!showGeoMaps2){
            setSelectedVehicleId(null);
            setServiceType(null)
          }
      },[showGeoMaps2])

  const handleDialog = (currentValue) => {
      setQuoteDialog(true);
      setFormData({...formData, vehicleCategory: currentValue?.vehicalName, vehicleCapacity:currentValue?.passengersNumber , luggageCapacity:currentValue?.suitcasesNumber });
    };
  
 useEffect(() => {
  const safeFare = parseFloat(fare) || 0;
  const safeExtra = parseFloat(bookingExtraTotal) || 0;

  setTotalFare((safeFare + safeExtra).toFixed(2));
}, [fare, bookingExtraTotal]);

useEffect(() => {
  const safeReturnFare = parseFloat(totalFare*2) || 0;
  
  if(journey=="Return"){
    setTotalReturnFare((safeReturnFare).toFixed(2));
  }
  else{
    setTotalReturnFare((0).toFixed(2));
  }
}, [fare, bookingExtraTotal,journey,totalFare]);


  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paymentStatus = params.get("redirect_status");
    const paymentIntentId = params.get("payment_intent");
    if (paymentStatus === "succeeded" && paymentIntentId) {
      axios
        .get(`${process.env.REACT_APP_URL}api/booking/get-payment-intent/${paymentIntentId}`) ///////////////////////////////////////////////////////////////
        .then((response) => {
          const paymentIntent = response.data;
          const paymentMethodDetails = paymentIntent.payment_method_details;
    
          
          if (paymentMethodDetails?.type === "card") {
            setShowWhiteScreen(true);
            setPaymentTypeOnline()
            //toast.success("Payment successful2");
            setPayType("Card");
          } else {
            setShowWhiteScreen(true);
            toast.success("Payment successful3");
            setPayType("Unknown");
          }
  
          setPaymentCompleted(true);
        })
        .catch((error) => {
          console.error("Error fetching payment intent:", error);
          setPaymentCompleted(false);
        });
    } else {
      setPaymentCompleted(false);
    }
  }, [paymentCompleted, payType]);
  
  useEffect(() => {
    const fetchData = async () => {      
      // if (
      //   payType &&
      //   paymentCompleted &&
      //   (!fromLocation.includes("Airport") &&
      //    !fromLocation.includes("Flughafen") &&
      //    !fromLocation.includes("Terminal"))
      // ) {
      //   handleDone();
      // } else if (
      //   payType &&
      //   paymentCompleted &&
      //   (fromLocation.includes("Airport") ||
      //    fromLocation.includes("Flughafen") ||
      //    fromLocation.includes("Terminal")) &&
      //   flightNum
      // ) {
      //   handleDone();
      // }
      if (payType && paymentCompleted) {
      handleClick(); // Let handleDone() handle the rest
    }
    };
  fetchData();
  }, [payType, paymentCompleted, flightNum]);

//  if (showWhiteScreen) {
//     return (
//       <div
//         style={{
//           width: "100vw",
//           height: "100vh",
//           backgroundColor: "white",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         <h1 style={{ fontSize: "2rem", fontWeight: "bold", color: "#000" }}>
//           Please wait your booking is processing....
//         </h1>
//       </div>
//     );
//   }
// useEffect(() => {
//   localStorage.setItem("selectedChildSeats", JSON.stringify(selectedChildSeats));
//   localStorage.setItem("selectedExtras", JSON.stringify(selectedExtras));
//   localStorage.setItem("selectedPackages", JSON.stringify(selectedPackages));
// }, [selectedChildSeats, selectedExtras, selectedPackages]);



  
    const setPaymentTypeOnline = async () => {
      const paymentData = {
      _id: localStorage.getItem("bookingId"),
      paymentType: "Card",
      failStatus: "Pass"
    };

      try {
        const res=await axios.post(
          `${process.env.REACT_APP_URL}api/booking/updateRideStatusAndPaymentType`,///////////////////////////////////////////////////////////////////payment issue
          paymentData
        );
        
        console.log("hellRes",res)
        if (res?.status === 200) {
          toast.success("Payment successful");
          navigate(paths.company.dashboard);
      }
        
      } catch (error) {
        console.error("Failed to update payment type:", error);
      }
    };

  const handleOpen = async (amount) => {
    if (paymentCompleted) {
      if (!toast.isActive(toastId)) {
        toast.info("Payment already done. You cannot change it now.", {
          toastId,
          autoClose: 2500,
        });
      }
      return;
    }

    setOpen(true);
    setPayType("Stripe");

    try {
      const response = await axios.post(`${process.env.REACT_APP_URL}api/booking/createBusinessAgentPaymentIntent`, {
        amount: Math.round(amount * 100), // Convert to cents
        currency: "eur",
      });
      setClientSecret(response.data.clientSecret);
    } catch (error) {
      console.error("Error creating payment intent:", error);
      toast.error("Error creating payment intent");
    }
  };

  const handleClose = () => {
    setOpen(false);
    setPayType('');
    setPaymentCompleted(false);
  };

  const CheckoutForm = ({ setPayType, handleClose, paymentCompleted, setPaymentCompleted, bookingId,dataCheck }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);
  
    const handleSubmit1 = async (e) => {
      e.preventDefault();
      if (!stripe || !elements) {
        toast.error("Stripe.js has not loaded yet.");
        return;
      }
    
      setLoading(true);
    
      try {
    
        const { error, paymentIntent } = await stripe.confirmPayment({
          elements, 
          confirmParams: {
            return_url: window.location.origin + "/company/BussinessBooking",
          },
        });
        if (error) {
          toast.error(`Payment failed2.0: ${error.message}`);
        } else if (paymentIntent) {
  
    
          if (paymentIntent.status === "requires_action") {
            toast.info("Payment requires additional action.");
          } else if (paymentIntent.status === "succeeded") {
            navigate(paths.company.dashboard);
            toast.success("Payment successful4");
            //handleClick()
            setPaymentCompleted(true);
          } else {
            toast.error(`Payment status: ${paymentIntent.status}`);
          }
        }
      } catch (err) {
        toast.error("Payment failed due to an unexpected error.");
        console.error("Payment error:", err);
      }
    
      setLoading(false);
    };
    
    
  
    return (
      <form onSubmit={handleSubmit1}>
        <Typography variant="h6" textAlign="center" sx={{ mb: 4 }}>
          Enter Payment Details
        </Typography>
        <PaymentElement />
        <Button
          type="submit"
          disabled={!stripe || loading}
          variant="contained"
          color="primary"
          //onClick={setPaymentTypeOnline}
          fullWidth
          sx={{ mt: 4 }}
        >
          {loading ? "Processing..." : "Pay Now"}
        </Button>
      </form>
    );
  };

  // useEffect(()=>{
  //   handleClick()
  // },[payCheck])
  const callHandleClick=(check,status)=> {
      
      if(check=="Cash"){
        setIsCashLoading(true)
      }
      else if(check=="Card"){
        setIsCardLoading(true)
      }
      else if(check=="Bank Invoice"){
        setBankInvoiceLoading(true)
      }
    console.log("bookingIdL",bookingId)
    if(bookingId){
      addcontactDetails(check,status)
    }
    else{
    console.log("bookingIdL2",bookingId)
    handleClick(check,status)
    }
  }

  const fetchUserProfileData = async () => {
    let obj = {
      userId: _userId,
    };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/user/getUserProfile`,
        obj
      );
      setCommissionPercentage(parseFloat(res?.data?.data?.companyAgentComission));
      setCompanyAgentEmail(res?.data?.data?.email)
      setLimit(res?.data?.data?.companyAgentLimit)
      console.log("aio")
    } catch (error) {}
  };

  useEffect(()=>{
    fetchUserProfileData()
  },[])

  const fetchCompanyProfileData = async () => {
    let obj = {
      role:"2",
      companyName:employeeCompany
    };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/user/CompanyProfileData`,
        obj
      );
      setEmployeeCompanyId(res?.data?.data?._id)
      console.log("aio",res?.data?.data?._id)
    } catch (error) {}
  };
  useEffect(()=>{
    fetchCompanyProfileData()
  },[employeeCompany])
  useEffect(()=>{
    if(selectedVehicleId==null){
      setShowGeoMaps(false) // unselect

    }

  },[selectedVehicleId])

  useEffect(()=>{
    console.log("serviceType",serviceType)
  },[serviceType])

  useEffect(() => {
  if (Object.keys(errorDetails).length > 0) {
    if (errorDetails.fName && fNameRef.current) {
      fNameRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      fNameRef.current.focus();
    } else if (errorDetails.lName && lNameRef.current) {
      lNameRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      lNameRef.current.focus();
    } else if (errorDetails.email && emailRef.current) {
      emailRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      emailRef.current.focus();
    } else if (errorDetails.numbers && phoneRef.current) {
      phoneRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      phoneRef.current.focus();
    } 
    // else if (errors.fromLocation && fromLocationRef.current) {
    //   fromLocationRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    //   fromLocationRef.current.focus();
    // } else if (errors.toLocation && toLocationRef.current) {
    //   toLocationRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    //   toLocationRef.current.focus();
    // }
  }
}, [errorDetails, errors]);

    return (
      <>
        <div className="container-fluid container-main">
          <Box sx={{ p: 3 }}>
            <div className="top-heading mb-4">Ride Booking</div>
            {role !== "2.1" && (
            <div
              className="d-flex justify-content-between px-3 py-3"
              style={{
                alignItems: "center",
                gap: "12px",
              }}
            >
              <div
                className="d-flex"
                style={{ alignItems: "center", gap: "12px" }}
              >
                <label className="label">Your Bank invoice limit (€):</label>
                <input
                  type="text"
                  value={limit}
                  style={{
                    width: "175px",
                    height: "36.5px",
                    backgroundColor: "white",
                    border: "2px solid #ccc",
                    borderRadius: "4px",
                    padding: "6px 10px",
                    fontSize: "14px",
                    outline: "none",
                    boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.05)",
                    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#1976d2";
                    e.target.style.boxShadow =
                      "0 0 0 2px rgba(25, 118, 210, 0.2)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#ccc";
                    e.target.style.boxShadow =
                      "inset 0 1px 2px rgba(0, 0, 0, 0.05)";
                  }}
                />
              </div>
               <div
                className="d-flex"
                style={{ alignItems: "center", gap: "12px" }}
              >
                <label className="label">Your remaining or consumed invoice limit (€):</label>
                <input
                  type="text"
                  value={"0"}
                  style={{
                    width: "175px",
                    height: "36.5px",
                    backgroundColor: "white",
                    border: "2px solid #ccc",
                    borderRadius: "4px",
                    padding: "6px 10px",
                    fontSize: "14px",
                    outline: "none",
                    boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.05)",
                    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#1976d2";
                    e.target.style.boxShadow =
                      "0 0 0 2px rgba(25, 118, 210, 0.2)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#ccc";
                    e.target.style.boxShadow =
                      "inset 0 1px 2px rgba(0, 0, 0, 0.05)";
                  }}
                />
              </div>
            </div>
            )}
            <Paper className="p-3 pe-4">
              <div className="page-heading">Ride Details</div>

              <div className="row my-1">
                <div className="col-md-6 pe-4">
                  {/* <div className='col-md-12 my-2 p-2 border'>
                            <label className='label-admin-text'>FROM</label>
                            <p className='text-admin'>rata Thai Massage, Hauptstraße, Eppelheim, Germany</p>
                        </div> */}
                  <div className="div-100 border mb-4 px-3 pt-2">
                    <label className="label-admin-text" htmlFor="address">
                      From
                    </label>
                    <Autocomplete
                      onLoad={(ref) => (inputRef.current = ref)}
                      onPlaceChanged={handlePlaceChange}
                      // types={["(regions)"]}
                      // options={{
                      //   types: ["(regions)"],
                      //   componentRestrictions: { country: "DE" }, // Replace 'DE' with the desired country code
                      // }}
                      types="(geocode)"
                      options={{
                        types: ["geocode", "establishment"],
                        componentRestrictions: {
                          country: [
                            "de",
                            "at",
                            "be",
                            "bg",
                            "cy",
                            "cz",
                            "dk",
                            "ee",
                            "es",
                            "fi",
                            "fr",
                            "gr",
                            "hr",
                            "hu",
                            "ie",
                            "it",
                            "lt",
                            "lu",
                            "lv",
                            "mt",
                            "nl",
                            "pl",
                            "pt",
                            "ro",
                            "se",
                            "si",
                            "sk",
                          ],
                        },
                        fields: [
                          "destination",
                          "formatted_address",
                          "address_components",
                          "geometry",
                          "types",
                          "name",
                        ],
                      }}
                    >
                      <TextField
                        sx={{
                          border: "none",
                          width: "100%",
                          "& .MuiOutlinedInput-root": {
                            "& > fieldset": {
                              border: "none",
                            },
                          },
                        }}
                        type="address"
                        id="address"
                        name="address"
                        className="text-admin"
                        value={fromLocation}
                        onChange={(e) => setFromLocation(e.target.value)}
                        error={Boolean(errorFromLocation)}
helperText={errorFromLocation}
                        placeholder="Enter Pick Up Location"
                      />
                    </Autocomplete>
                  </div>
                  {/* <div className='col-md-12 my-2 p-2 border'>
                            <label className='label-admin-text '>TO</label>
                            <p className='text-admin'>rata Thai Massage, Hauptstraße, Eppelheim, Germany</p>
                        </div> */}
                  <div className="col-md-12 mb-4 px-3 pt-2 border">
                    <label className="label-admin-text" htmlFor="address">
                      To
                    </label>
<Autocomplete
  onLoad={(ref) => (toRef.current = ref)}  // onLoad should be properly setting the reference
  onPlaceChanged={() => handlePlaceToChange()}  // Update this to pass `toRef.current.getPlace()`
  types="(geocode)"
  options={{
    types: ["geocode", "establishment"],
    componentRestrictions: {
      country: [
        "de", "at", "be", "bg", "cy", "cz", "dk", "ee", "es", "fi", "fr", "gr", 
        "hr", "hu", "ie", "it", "lt", "lu", "lv", "mt", "nl", "pl", "pt", "ro", 
        "se", "si", "sk"
      ],
    },
    fields: [
      "destination", "formatted_address", "address_components", 
      "geometry", "types", "name"
    ],
  }}
>
  <TextField
    sx={{
      border: "none",
      width: "100%",
      "& .MuiOutlinedInput-root": {
        "& > fieldset": {
          border: "none",
        },
      },
    }}
    type="address"
    id="address"
    name="address"
    value={toLocation}  // This binds the value correctly to state
    onChange={(e) => setToLocation(e.target.value)}  // Updates state on manual changes
    error={Boolean(errorToLocation)}
    helperText={errorToLocation}
    className="text-admin"
    placeholder="Enter Drop Off Location"
  />
</Autocomplete>


                  </div>
                  {/* <div className="w-100 mb-4 overflow-hidden">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DateTimePicker"]}>
                        <MobileDateTimePicker
                          format="DD/MM/YYYY HH:mm"
                          label="Pickup Date & Time"
                          value={datee}
                          onChange={handleDateChange}
                          maxDate={maxDate}
                          readOnly={!fromLocation}
                          ampm={false}
                          
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                </div> */}
                  <div className="w-100 mb-4 date-time-picker-wrapper">
                    <style>
                      {`
      .date-time-picker-wrapper::-webkit-scrollbar {
        width: 0px;
        background: transparent;
      }

      .date-time-picker-wrapper {
        scrollbar-width: none; /* Firefox */
        overflow-x: hidden; /* Prevent horizontal scroll */
      }
    `}
                    </style>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                       <div
                                                 onClick={() => {
                        if (!isFromLocationSelected) {
                          toast.error("Select Pickup location First", { 
                            autoClose: 2500,
                            toastId: "pickup-location-error" 
                          });
                          return;
                        } 
                      }}
                      
                                                >
                      <DemoContainer components={["DateTimePicker"]}>
                        <MobileDateTimePicker
                          format="DD/MM/YYYY HH:mm"
                          label="Pickup Date & Time"
                          value={datee}
                          minDateTime={minDateTime}
                          onChange={handleDateChange}
                          maxDate={maxDate}
                          readOnly={!isFromLocationSelected}
                          ampm={false}
                          disablePortal
                          onOpen={() => {
                            if (!isFromLocationSelected) {
                              toast.error("Select Pickup location First", { 
                                autoClose: 2500,
                                toastId: "pickup-location-error"
                              });
                              return false;
                            }
                          }}
                          sx={{}}
                        />
                      </DemoContainer>
                      </div>
                    </LocalizationProvider>
                  </div>
                  <div className="w-100 mb-4">
                    <Box>
                      <FormControl
                        fullWidth
                        size="small"
                        error={!!errors.extraTime}
                      >
                        <InputLabel>Extra Time</InputLabel>
                        <Select
                          label="Extra Time"
                          value={extraTime}
                          onChange={(e) => {
                            setExtraTime(e.target.value);
                            setShowGeoMaps(false);
                            setShowGeoMaps2(false);
                          }}
                        >
                          <MenuItem value="0">0</MenuItem>
                          <MenuItem value="30 min">30 min</MenuItem>
                          <MenuItem value="1 hours">1 hours</MenuItem>
                          <MenuItem value="2 hours">2 hours</MenuItem>
                          <MenuItem value="3 hours">3 hours</MenuItem>
                        </Select>
                        {errors.extraTime && (
                          <FormHelperText>{errors.extraTime}</FormHelperText>
                        )}
                      </FormControl>
                    </Box>
                  </div>
                  {/* <div className="w-100 mb-4">
                  <Box>
                    <FormControl fullWidth size="small" error={!!errors.tax}>
                      <InputLabel>Tax %</InputLabel>
                      <Select
                        label="Tax %"
                        value={taxApplied}
                        onChange={(event) => {
                          setTaxApplied(event.target.value);
                          setShowGeoMaps(false);
                        }} // Directly setting the value here
                      >
                        <MenuItem value={0}>0%</MenuItem>
                        <MenuItem value={1}>1%</MenuItem>
                        <MenuItem value={2}>2%</MenuItem>
                        <MenuItem value={3}>3%</MenuItem>
                        <MenuItem value={4}>4%</MenuItem>
                        <MenuItem value={5}>5%</MenuItem>
                        <MenuItem value={6}>6%</MenuItem>
                        <MenuItem value={7}>7%</MenuItem>
                        <MenuItem value={8}>8%</MenuItem>
                        <MenuItem value={9}>9%</MenuItem>
                        <MenuItem value={10}>10%</MenuItem>
                        <MenuItem value={11}>11%</MenuItem>
                        <MenuItem value={12}>12%</MenuItem>
                        <MenuItem value={13}>13%</MenuItem>
                        <MenuItem value={14}>14%</MenuItem>
                        <MenuItem value={15}>15%</MenuItem>
                        <MenuItem value={16}>16%</MenuItem>
                        <MenuItem value={17}>17%</MenuItem>
                        <MenuItem value={18}>18%</MenuItem>
                        <MenuItem value={19}>19%</MenuItem>
                        <MenuItem value={20}>20%</MenuItem>
                        <MenuItem value={21}>21%</MenuItem>
                        <MenuItem value={22}>22%</MenuItem>
                        <MenuItem value={23}>23%</MenuItem>
                        <MenuItem value={24}>24%</MenuItem>
                        <MenuItem value={25}>25%</MenuItem>
                      </Select>
                      {errors.tax && (
                        <FormHelperText>{errors.tax}</FormHelperText>
                      )}
                    </FormControl>
                  </Box>
                </div> */}

                  <div className="w-100 p-0 mb-4">
                    <Box>
                      <FormControl
                        fullWidth
                        size="small"
                        error={errors.journey}
                      >
                        <InputLabel id="JOURNEY TYPE">Journey Type</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          value={journey}
                          label="JOURNEY TYPE"
                          onChange={handleJourney}
                        >
                          <MenuItem value={"One Way"}>One Way</MenuItem>
                          <MenuItem value={"Return"}>Return</MenuItem>
                        </Select>
                        {errors.journey && (
                          <FormHelperText>{errors.journey}</FormHelperText>
                        )}
                      </FormControl>
                    </Box>
                  </div>

                  {/* <div className="w-100 mb-4">
                    <TextField
                      fullWidth
                      type="number"
                      size="small"
                      label="Passengers"
                      value={passengers}
                      onChange={(e) =>{
                        const val = parseInt(e.target.value, 10);
                        if (val >= 1 || e.target.value === "") {
                          setShowGeoMaps(false);
                          setPassengers(e.target.value);
                        }
                      }}
                      inputProps={{ min: 1}}
                      
                      error={!!errors.passengers}
                      helperText={errors.passengers}
                    />
                  </div> */}
                  {journey === "Return" && (
                    <div className="w-100 mb-4 overflow-hidden">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DateTimePicker"]}>
                          <MobileDateTimePicker
                            label="Return Date & Time"
                            format="DD/MM/YYYY HH:mm"
                            value={returnDate}
                            readOnly={!datee || !fromLocation || !toLocation}
                            onChange={(newValue) => {
                              setReturnDate(newValue);
                              setShowGeoMaps(false);
                              setShowGeoMaps2(false);
                            }}
                            minDateTime={minDatee}
                            maxDate={maxDate}
                            onError={errors.returnDate}
                            ampm={false}
                          />
                        </DemoContainer>
                        {errors.returnDate && (
                          <FormHelperText className="text-danger">
                            {errors.returnDate}
                          </FormHelperText>
                        )}
                      </LocalizationProvider>
                    </div>
                  )}
                  {/* {journey === "Return" && (
                  <div className="w-100 mb-4">
                  <TextField
                    fullWidth
                    type="number"
                    size="small"
                    label="Return Passengers"
                    value={returnPassengers}
                    onChange={(e) =>{

                      const val = parseInt(e.target.value, 10);
                      if (val >= 1 || e.target.value === "") {
                        setShowGeoMaps(false);
                        setReturnPassengers(e.target.value)
                      }
                      
                    }}
                    //inputProps={{ min: 1, max: 99 }}
                    error={!!errors.returnPassengers}
                    helperText={errors.returnPassengers}
                  />
                </div>
                )} */}
                  {journey === "Return" && (
                    <div className="w-100 mb-4">
                      <Box>
                        <FormControl
                          fullWidth
                          size="small"
                          error={!!errors.returnExtraTime}
                        >
                          <InputLabel>Return Extra Time</InputLabel>
                          <Select
                            sx={{
                              "@media (max-width: 820px)": {
                                "& .MuiInputBase-input": {
                                  paddingLeft: "30px",
                                },
                              },
                            }}
                            label="Return Extra Time"
                            value={returnExtraTime}
                            onChange={(e) => {
                              setReturnExtraTime(e.target.value);
                              setShowGeoMaps(false);
                              setShowGeoMaps2(false);
                            }}
                          >
                            <MenuItem value="0">0</MenuItem>
                            <MenuItem value="30 min">30 min</MenuItem>
                            <MenuItem value="1 hours">1 hours</MenuItem>
                            <MenuItem value="2 hours">2 hours</MenuItem>
                            <MenuItem value="3 hours">3 hours</MenuItem>
                          </Select>
                          {errors.returnExtraTime && (
                            <FormHelperText>
                              {errors.returnExtraTime}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </Box>
                    </div>
                  )}
                  {/* <Button
                  variant="contained"
                  className="px-4"
                  onClick={handleHomepage}
                >
                  Submit
                </Button> */}

                  <Button
                    variant="contained"
                    className="px-4"
                    onClick={handleHomepage}
                  >
                    Select Vehicle
                  </Button>
                  {bookingId && (
                    <Button
                      variant="contained"
                      className="px-4"
                      style={{ backgroundColor: "red", left: "1vw" }}
                      onClick={() => {
                        discardBooking();
                        window.location.reload();
                      }}
                      //onClick={() => window.location.reload()}
                    >
                      Discard
                    </Button>
                  )}
                </div>

                <div className="col-md-6 white-card border p-3 mb-5">
                  <table className="table table-bordered" width="100%">
                    <tr>
                      <th className="px-2 text-admin table-th">Journey Type</th>
                      <td className="text-admin">
                        <TextField
                          sx={{
                            border: "none",
                            width: "100%",
                            "& .MuiOutlinedInput-root": {
                              "& > fieldset": {
                                border: "none",
                              },
                            },
                          }}
                          type="text"
                          value={journeyType}
                          onChange={(e) => setJourneyType(e.target.value)}
                          placeholder="xx"
                          className="text-admin"
                          inputProps={{ readOnly: true }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th className="px-2 text-admin table-th">
                        Distance in Kilometer
                      </th>
                      <td className="text-admin">
                        <TextField
                          sx={{
                            border: "none",
                            width: "100%",
                            "& .MuiOutlinedInput-root": {
                              "& > fieldset": {
                                border: "none",
                              },
                            },
                          }}
                          type="text"
                          value={distanceKm}
                          onChange={(e) => setDistanceKM(e.target.value)}
                          placeholder="xx"
                          className="text-admin"
                          inputProps={{ readOnly: true }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th className="px-2 text-admin table-th">
                        Pickup Date & Time
                      </th>
                      <td className="text-admin">
                        <TextField
                          sx={{
                            border: "none",
                            width: "100%",
                            "& .MuiOutlinedInput-root": {
                              "& > fieldset": {
                                border: "none",
                              },
                            },
                          }}
                          type="text"
                          // value={dayjs(pickUpDate).format("DD/MM/YYYY HH:mm")}
                          value={pickUpDate}
                          onChange={(e) => setPickupDate(e.target.value)}
                          placeholder="xx"
                          className="text-admin"
                          inputProps={{ readOnly: true }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th className="px-2 text-admin table-th">Duration</th>
                      <td className="text-admin">
                        <TextField
                          multiline
                          sx={{
                            border: "none",
                            width: "100%",
                            overflow: "none",
                            "& .MuiOutlinedInput-root": {
                              "& > fieldset": {
                                border: "none",
                              },
                            },
                          }}
                          type="text"
                          value={duration1}
                          onChange={(e) => setDuration1(e.target.value)}
                          placeholder="xx"
                          className="text-admin"
                          inputProps={{ readOnly: true }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th className="px-2 text-admin table-th">Route</th>
                      <td className="text-admin">
                        <TextField
                          multiline
                          sx={{
                            border: "none",
                            width: "100%",
                            overflow: "none",
                            "& .MuiOutlinedInput-root": {
                              "& > fieldset": {
                                border: "none",
                              },
                            },
                          }}
                          type="text"
                          value={route}
                          onChange={(e) => setRoute(e.target.value)}
                          placeholder="xx"
                          className="text-admin"
                          inputProps={{ readOnly: true }}
                        />
                      </td>
                    </tr>
                    {/* <tr>
                                <th className='text-admin table-th'>Fare:</th>
                                <td className='text-admin'>
                                    <TextField
                                        sx={{border:"none",width:"100%",
                                        "& .MuiOutlinedInput-root": {
                                            "& > fieldset": {
                                            border: "none"
                                            }
                                        }}}
                                        type='text'
                                        // value={distanceMiles}
                                        // onChange={(e) => setDistanceMiles(e.target.value)}
                                        placeholder='60'
                                        className='text-admin'
                                        />
                                </td>
                            </tr> */}
                  </table>
                </div>
              </div>
              {showGeoMaps2 && (
                <div className="col-md-9 p-2">
                  <h5 className="px-3" style={{ color: "#1F3648" }}>
                    Vehicle List (One Way Price){" "}
                    <span style={{ fontSize: "14px" }}>tax incuded*</span>
                  </h5>
                  <div>
                    <div className="col-md-11 col-sm-6 my-3 forVehicleImage">
                      {Object.keys(groupedVehicles).length > 0 ? (
                        Object.keys(groupedVehicles).map(
                          (vehicleClass, index) => (
                            <div key={index}>
                              {/* Vehicle Class Header */}
                              <h3 className="mt-4">{vehicleClass}</h3>

                              {/* Render vehicles for this class */}
                              {groupedVehicles[vehicleClass].map(
                                (currentValue) => (
                                  <div
                                    className="card mt-2 white-card"
                                    key={currentValue._id}
                                  >
                                    <div className="card-body">
                                      <Grid container>
                                        {/* Vehicle Image */}
                                        <Grid
                                          item
                                          md={5}
                                          xm={4}
                                          textAlign="center"
                                        >
                                          <div>
                                            <img
                                              src={currentValue?.vehicalImage}
                                              alt="Card image cap"
                                              onError={(e) => {
                                                e.target.src = Scorpio;
                                              }}
                                              style={{
                                                width: "100%",
                                                height: "12rem",
                                                objectFit: "contain",
                                              }}
                                            />
                                          </div>
                                        </Grid>

                                        {/* Vehicle Details */}
                                        <Grid item md={5} xm={4} spacing={2}>
                                          <div className="p-2">
                                            <label className="vehicle-type mt-1">
                                              {currentValue?.vehicalStandard}
                                            </label>
                                            <div className="d-flex flex-wrap gap-2 mt-2">
                                              <div className="d-flex justify-content-center gap-2">
                                                <div>
                                                  <img
                                                    src={user}
                                                    className=""
                                                  />
                                                </div>
                                                <div>
                                                  <p className="people-bag">
                                                    {
                                                      currentValue?.passengersNumber
                                                    }{" "}
                                                    People
                                                  </p>
                                                </div>
                                              </div>
                                              <div className="d-flex gap-2 justify-content-center">
                                                <div>
                                                  <img src={bag} />
                                                </div>
                                                <div>
                                                  <p className="people-bag">
                                                    {
                                                      currentValue?.suitcasesNumber
                                                    }{" "}
                                                    Bag
                                                  </p>
                                                </div>
                                              </div>
                                            </div>

                                            <p className="vehicle-card-text">
                                              {currentValue?.vehicalModel &&
                                                `${currentValue?.vehicalModel}, `}
                                              {currentValue?.vehicalName &&
                                                `${currentValue?.vehicalName}, `}
                                              {currentValue?.company}
                                            </p>
                                          </div>
                                        </Grid>

                                        {currentValue?.vehicleClassDetail
                                          ?.onCall &&
                                        currentValue?.vehicleClassDetail
                                          ?.onCall === true ? (
                                          <Grid
                                            item
                                            md={2}
                                            textAlign="center"
                                            sx={{
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                            }}
                                          >
                                            <button
                                              className="btn-select py-2 px-3"
                                              onClick={() =>
                                                handleDialog(currentValue)
                                              }
                                            >
                                              Get a Quote
                                            </button>
                                          </Grid>
                                        ) : (
                                          <Grid item md={2} textAlign="center">
                                            <div className="mt-4">
                                              <p className="veh-price">
                                                {parseFloat(
                                                  currentValue?.price
                                                ).toFixed(2)}{" "}
                                                &#8364;
                                              </p>
                                              <div>
                                                <button
                                                  className="btn-select py-2 px-3"
                                                  onClick={() => {
                                                    if (
                                                      selectedVehicleId ===
                                                      currentValue._id
                                                    ) {
                                                      setSelectedVehicleId(
                                                        null
                                                      );
                                                      setServiceType(null)
                                                    } else {
                                                      setSelectedVehicleId(
                                                        currentValue?._id
                                                      ); // select
                                                      setServiceType(currentValue?.serviceType)
                                                    }
                                                    handleCarSelect(
                                                      currentValue
                                                    );
                                                    setTaxApplied(
                                                      currentValue.tax
                                                    );
                                                    console.log(
                                                      "currentValue",
                                                      currentValue
                                                    );
                                                  }}
                                                  style={
                                                    selectedVehicleId ===
                                                    currentValue._id
                                                      ? {
                                                          backgroundColor:
                                                            "#0E4672",
                                                          color: "white",
                                                          // border: "1px solid #0E4672",
                                                        }
                                                      : {}
                                                  }
                                                >
                                                  {selectedVehicleId ===
                                                  currentValue._id
                                                    ? "Selected"
                                                    : "Select"}
                                                </button>
                                              </div>
                                            </div>
                                          </Grid>
                                        )}
                                      </Grid>
                                    </div>
                                  </div>
                                )
                              )}
                            </div>
                          )
                        )
                      ) : loading === false && loadingTwo === false ? (
                        <p>No vehicle found</p>
                      ) : (
                        <p>Loading....</p>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {showGeoMaps && (
                <div>
                  <div className="col-md-12 heading-section ">
                    Customer Details
                  </div>

                  <div className="row my-3 gap-4 ">
                    {/* <div className='col-md-3 white-card p-3 border' style={{ backgroundColor: "#F1F9FF" }}>
                                    <label className='label-admin-text'>Vorname*</label>
                                    <p className='text-admin'>HET</p>
                                </div> */}
                    {/* <div className='col-md-4 white-card p-3 border'>
                                    <label className='label-admin-text'>E-mail Adresse*</label>
                                    <p className='text-admin'>demo133@gmail.com</p>

                                </div> */}
                    <div style={{ padding: "0vw 1.5vw" }}>
                      <div className="row">
                        <div className="col-md-4 white-card p-3 border">
                          <label className="label-admin-text" htmlFor="fName">
                            First Name*
                          </label>
                          <TextField
                            sx={{
                              border: "none",
                              width: "100%",
                              "& .MuiOutlinedInput-root": {
                                "& > fieldset": { border: "none" },
                              },
                            }}
                            inputRef={fNameRef}
                            type="text"
                            id="fName"
                            name="fName"
                            value={fName}
                            onChange={(e) => setFName(e.target.value)}
                            className="text-admin"
                            placeholder="First Name"
                            error={errorDetails.fName}
                            helperText={errorDetails.fName}
                            inputProps={{
                              maxLength: 100,
                              pattern: "[A-Za-z\\s]*",
                              onKeyPress: (e) => {
                                if (!/^[A-Za-z\s\-]*$/.test(e.key)) {
                                  e.preventDefault();
                                }
                              },
                            }}
                          />
                        </div>

                        <div className="col-md-4 white-card p-3 border">
                          <label className="label-admin-text" htmlFor="lName">
                            Last Name*
                          </label>
                          <TextField
                            sx={{
                              border: "none",
                              width: "100%",
                              "& .MuiOutlinedInput-root": {
                                "& > fieldset": { border: "none" },
                              },
                            }}
                            inputRef={lNameRef}
                            type="text"
                            id="lName"
                            name="lName"
                            value={lName}
                            onChange={(e) => setLName(e.target.value)}
                            className="text-admin"
                            placeholder="Last Name"
                            error={errorDetails.lName}
                            helperText={errorDetails.lName}
                            inputProps={{
                              maxLength: 100,
                              pattern: "[A-Za-z\\s]*",
                              onKeyPress: (e) => {
                                if (!/^[A-Za-z\s\-]*$/.test(e.key)) {
                                  e.preventDefault();
                                }
                              },
                            }}
                          />
                        </div>

                        <div className="col-md-4 white-card p-3 border">
                          <label className="label-admin-text" htmlFor="email">
                            E-mail Address*
                          </label>
                          <TextField
                            sx={{
                              border: "none",
                              width: "100%",
                              "& .MuiOutlinedInput-root": {
                                "& > fieldset": { border: "none" },
                              },
                            }}
                            inputRef={emailRef}
                            type="email"
                            id="email"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="text-admin"
                            placeholder="E-mail Address"
                            inputProps={{ maxLength: 100 }}
                            error={errorDetails.email}
                            helperText={errorDetails.email}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4 white-card p-3 border">
                          <label className="label-admin-text" ref={phoneRef}>
                            Telefonummer*
                          </label>
                          <PhoneInput
                            
                            country={"de"}
                            value={numbers.phone}
                            onChange={(phone) => setNumbers(phone)}
                            inputStyle={{ width: "100%" }}
                          />
                          {errorDetails.numbers && (
                            <small
                              style={{ color: "#d32f2f", fontWeight: 400 }}
                            >
                              {errorDetails.numbers}
                            </small>
                          )}
                        </div>

                        {(fromLocation.toLowerCase().includes("airport") ||
                          fromLocation.toLowerCase().includes("flughafen") ||
                          fromLocation.toLowerCase().includes("terminal")) && (
                          <div className="col-md-4 white-card p-3 border">
                            <label className="label-admin-text">
                              Flight Number
                            </label>
                            <TextField
                              sx={{
                                border: "none",
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                  "& > fieldset": { border: "none" },
                                },
                              }}
                              fullWidth
                              variant="outlined"
                              size="small"
                              value={flightNum}
                              onChange={(e) => setFlightNum(e.target.value)}
                              className="text-admin"
                              placeholder="Enter Flight Number"
                            />
                          </div>
                        )}

                        {(toLocation.toLowerCase().includes("airport") ||
                          toLocation.toLowerCase().includes("flughafen") ||
                          toLocation.toLowerCase().includes("terminal")) &&
                          journeyType === "Return" && (
                            <div className="col-md-4 white-card p-3 border">
                              <label className="label-admin-text">
                                Return Flight Number
                              </label>
                              <TextField
                                sx={{
                                  border: "none",
                                  width: "100%",
                                  "& .MuiOutlinedInput-root": {
                                    "& > fieldset": { border: "none" },
                                  },
                                }}
                                fullWidth
                                variant="outlined"
                                size="small"
                                value={returnFlightNum}
                                onChange={(e) =>
                                  setReturnFlightNum(e.target.value)
                                }
                                className="text-admin"
                                placeholder="Enter Return Flight Number"
                                inputProps={{ maxLength: 25 }}
                              />
                            </div>
                          )}
                      </div>
                    </div>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      className="content-fields"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox checked={checked} onChange={handleChange} />
                        }
                        label="Billing Address"
                      />
                    </Grid>
                    {checked && (
                      <div className="  ">
                        <div>
                          <h6 style={{ color: "#1F3648" }}>Billing Address</h6>
                        </div>
                        <div className="card-body">
                          <div className="mt-3">
                            <AddressFormWrapper>
                              <Grid container>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={6}
                                  className="content-fields"
                                >
                                  <TextField
                                    fullWidth
                                    label="Company Name/Customer Name*"
                                    variant="outlined"
                                    value={companyName}
                                    error={companyNameError}
                                    //helperText={companyNameError}
                                    //onChange={(e) => setCompanyName(e.target.value)}
                                    onChange={(e) => {
                                      setCompanyName(e.target.value);
                                    }}
                                    //inputProps={{ maxLength: 250 }}
                                  />
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={6}
                                  className="content-fields"
                                >
                                  <TextField
                                    label="Tax Number"
                                    variant="outlined"
                                    fullWidth
                                    value={taxNumber}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      // Allow only alphanumeric characters
                                      const sanitizedValue = value.replace(
                                        /[^a-zA-Z0-9]/g,
                                        ""
                                      );
                                      setTaxNumber(sanitizedValue);
                                    }}
                                    error={!!taxNumberErrorText}
                                    helperText={taxNumberErrorText}
                                    inputProps={{ maxLength: 15 }}
                                  />
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={4}
                                  className="content-fields"
                                >
                                  <select
                                    style={{
                                      border: "none",
                                      width: "100%",
                                      height: "100%",
                                    }}
                                    onChange={(e) => {
                                      const selectedOption = countryList.find(
                                        (item) =>
                                          item.isoCode === e.target.value
                                      );
                                      setCountry(e.target.value);
                                      setCountryName(
                                        selectedOption?.name || ""
                                      );
                                    }}
                                    value={country}
                                  >
                                    <option>Select Country</option>

                                    {countryList?.length > 0 &&
                                      countryList?.map((currentValue) => {
                                        return (
                                          <option value={currentValue.isoCode}>
                                            {currentValue.name}
                                          </option>
                                        );
                                      })}
                                  </select>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={4}
                                  className="content-fields"
                                >
                                  <select
                                    style={{
                                      width: "100%",
                                      height: "40px",
                                      border: "none",
                                    }} // Set a fixed height
                                    disabled={
                                      !country ||
                                      countryList.length === 0 ||
                                      stateList.length == 0
                                    }
                                    value={stateRegion}
                                    onChange={(e) => {
                                      const selectedOption = stateList.find(
                                        (item) =>
                                          item.isoCode === e.target.value
                                      );
                                      setStateRegion(e.target.value);
                                      setStateName(selectedOption?.name || "");
                                    }}
                                  >
                                    <option>State or Region</option>
                                    {stateList?.length > 0 &&
                                      stateList?.map((currentValue, i) => {
                                        return (
                                          <option
                                            key={i}
                                            value={currentValue.isoCode}
                                          >
                                            {currentValue.name}
                                          </option>
                                        );
                                      })}
                                  </select>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={4}
                                  className="content-fields"
                                >
                                  <select
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      border: "none",
                                    }}
                                    disabled={
                                      !stateRegion ||
                                      stateList.length === 0 ||
                                      cityList.length === 0
                                    }
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                  >
                                    <option>City</option>

                                    {cityList?.length > 0 &&
                                      cityList?.map((currentValue, i) => {
                                        return (
                                          <option value={currentValue.isoCode}>
                                            {currentValue.name}
                                          </option>
                                        );
                                      })}
                                  </select>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={4}
                                  className="content-fields"
                                >
                                  <TextField
                                    fullWidth
                                    label="House Number"
                                    variant="outlined"
                                    value={address1}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      // Allow only alphanumeric characters
                                      const sanitizedValue = value.replace(
                                        /[^a-zA-Z0-9 ]/g,
                                        ""
                                      );
                                      setAddress1(sanitizedValue);
                                    }}
                                    inputProps={{ maxLength: 100 }}
                                  />
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={4}
                                  className="content-fields"
                                >
                                  <TextField
                                    fullWidth
                                    label="Street Name"
                                    variant="outlined"
                                    value={address2}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      // Allow only alphanumeric characters
                                      const sanitizedValue = value.replace(
                                        /[^a-zA-Z0-9 ]/g,
                                        ""
                                      );
                                      setAddress2(sanitizedValue);
                                    }}
                                    inputProps={{ maxLength: 100 }}
                                  />
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={4}
                                  className="content-fields"
                                >
                                  <TextField
                                    fullWidth
                                    label="Postal Code"
                                    variant="outlined"
                                    value={postal}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      // Allow only alphanumeric characters
                                      const sanitizedValue = value.replace(
                                        /[^a-zA-Z0-9\s\- ]/g,
                                        ""
                                      );
                                      setPostal(sanitizedValue);
                                    }}
                                    inputProps={{ maxLength: 10 }}
                                  />
                                </Grid>
                              </Grid>
                            </AddressFormWrapper>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-md-12 heading-section my-">
                    Booking Extra (Tax Applied:{taxApplied}%)
                  </div>

                  <div className="row gap-5 my-4 p-2 m-2 ">
                    <div className="col-md-5 border white-card p-1">
                      <div className="label-text ">
                        {" "}
                        <img
                          src={emoji}
                          width="50px"
                          style={{ marginRight: "10px" }}
                        />
                        Child Seat
                      </div>
                      <hr />
                      <div className="row border-bottom mx-2">
                        {/* <div className='col-md-8 text-admin'>Baby Seat (0 Months - 9 Months)</div>
                                        <div className='col-md-1 pb-2 label-text mt-auto'>{babySeatCount}</div>
                                        <div className='col-md-3'>
                                            <div className='rounded-pill d-flex'>
                                                <button className='w-50 puls-minus-btn-darkblue' onClick={handleBabySeatIncrement}>+</button>
                                                <button className='w-50 puls-minus-btn-skyblue' onClick={handleBabySeatDecrement}>-</button>
                                            </div>
                                        </div> */}
                        {childSeat?.length > 0 &&
                          // childSeat.map((currentValue, i) => {
                          //   return (
                          //     <AgentSubChild
                          //       currentValue={currentValue}
                          //       handleSelect={handleSelect}
                          //       globalNumberSum={globalNumberSum}
                          //       passengers={passengers}
                          //     />
                          //   );
                          // })
                          childSeat.map((currentValue, i) => {
                            return (
                              <AgentSubChild
                                key={currentValue._id}
                                currentValue={currentValue}
                                handleSelect={handleSelect}
                                //globalNumberSum={globalNumberSum}
                                isMaxReached={isMaxReached}
                                passengers={passengers}
                              />
                            );
                          })}
                      </div>
                    </div>
                    <div className="col-md-5 border white-card  p-3">
                      <div className="label-text ">
                        {" "}
                        <img
                          src={pakage}
                          width="40px"
                          style={{ marginRight: "10px" }}
                        />
                        Package
                      </div>
                      <hr />
                      <div className="row mx-2">
                        {packages?.length > 0 &&
                          packages?.map((currentValue, i) => (
                            <Table
                              sx={{ minWidth: 400 }}
                              aria-label="simple table"
                            >
                              <TableRow
                                className="py-1"
                                key={i}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell
                                  className="fw-bold"
                                  component="th"
                                  scope="row"
                                >
                                  <div className="fs-5 child-text">
                                    {currentValue.type}
                                  </div>
                                  <div>{currentValue.fame}</div>
                                  <div>{currentValue.desc}</div>
                                  <div className="child-price">
                                    {" "}
                                    &euro; {currentValue.price}
                                  </div>
                                </TableCell>
                                {/* <TableCell className="fw-bold bluetext fs-4" align="left">
                                                &euro; {currentValue.price}
                                            </TableCell> */}
                                <TableCell className="fw-bold" align="right">
                                  {/* {currentValue.flag === "1" ? (
                                  <Button
                                    variant="contained"
                                    onClick={() =>
                                      handleSelectService(currentValue._id, 0)
                                    }
                                  >
                                    Selected <CheckIcon />
                                  </Button>
                                  
                                ) : (
                                  <Button
                                    variant="outlined"
                                    onClick={() =>
                                      handleSelectService(currentValue._id, 1)
                                    }
                                  >
                                    Select
                                  </Button>
                                 
                                )} */}
                                  {selectedPackages[currentValue?._id] ? (
                                    <Button
                                      variant="contained"
                                      onClick={() =>
                                        handleSelectService(currentValue._id, 0)
                                      }
                                    >
                                      Selected <CheckIcon />
                                    </Button>
                                  ) : (
                                    <Button
                                      variant="outlined"
                                      onClick={() =>
                                        handleSelectService(
                                          currentValue._id,
                                          1,
                                          currentValue?.price
                                        )
                                      }
                                    >
                                      Select
                                    </Button>
                                  )}
                                </TableCell>
                              </TableRow>
                            </Table>
                          ))}
                      </div>
                      <hr />
                    </div>
                    <div className="col-md-5 border white-card">
                      <div className="label-text ">
                        {" "}
                        <img
                          src={disability1}
                          width="40px"
                          style={{ marginRight: "10px" }}
                        />
                        Extras
                      </div>
                      <hr />
                      <div className="row mx-2">
                        {extra?.length > 0 &&
                          extra.map((currentValue, i) => (
                            <TableRow
                              className="py-1"
                              key={i}
                              sx={{
                                "& td, & th": { borderBottom: "none" },
                              }}
                            >
                              <TableCell
                                className="fw-bold"
                                component="th"
                                scope="row"
                              >
                                <div className="fs-6 fw-bold">
                                  {currentValue.type}
                                </div>
                                <div className="fs-5 fw-bold bluetext">
                                  &euro;{currentValue.price}
                                </div>
                              </TableCell>
                              <TableCell className="fw-bold" align="right">
                                {/* {selectedExtraServices.includes(currentValue) ? ( */}
                                {/* {currentValue.flag === "1" ? (
                                <Button
                                  variant="contained"
                                  onClick={() =>
                                    handleExtraService(currentValue._id, 0)
                                  }
                                >
                                  Selected <CheckIcon />
                                </Button>
                              ) : (
                                <Button
                                  variant="outlined"
                                  onClick={() =>
                                    handleExtraService(currentValue._id, 1)
                                  }
                                >
                                  Select
                                </Button>
                              )} */}
                                {selectedExtras.hasOwnProperty(
                                  currentValue._id
                                ) ? (
                                  <Button
                                    variant="contained"
                                    onClick={() =>
                                      handleExtraService(currentValue?._id, 0)
                                    }
                                  >
                                    Selected <CheckIcon />
                                  </Button>
                                ) : (
                                  <Button
                                    variant="outlined"
                                    onClick={() =>
                                      handleExtraService(
                                        currentValue?._id,
                                        1,
                                        currentValue?.price
                                      )
                                    }
                                  >
                                    Select
                                  </Button>
                                )}
                                {/* )} */}
                              </TableCell>
                            </TableRow>
                          ))}
                      </div>
                      <hr />
                    </div>

                    <div className="col-md-5 border white-card">
                      <div className="label-text ">
                        Booking Extra Total With Tax
                      </div>
                      <hr />
                      <div className="row mx-2">
                        <TableRow
                          className="py-1"
                          sx={{
                            "& td, & th": { borderBottom: "none" },
                          }}
                        >
                          <TableCell
                            className="fw-bold"
                            component="th"
                            scope="row"
                          >
                            <div className="fs-6 fw-bold">
                              Child Seat Total:
                            </div>
                            <div className="fs-5 fw-bold bluetext">
                              &euro;{(childSeatTotal || 0).toFixed(2)}
                            </div>
                          </TableCell>
                        </TableRow>
                        <TableRow
                          className="py-1"
                          sx={{
                            "& td, & th": { borderBottom: "none" },
                          }}
                        >
                          <TableCell
                            className="fw-bold"
                            component="th"
                            scope="row"
                          >
                            <div className="fs-6 fw-bold">Package Total:</div>
                            <div className="fs-5 fw-bold bluetext">
                              &euro;{(packagesTotal || 0).toFixed(2)}
                            </div>
                          </TableCell>
                        </TableRow>
                        <TableRow
                          className="py-1"
                          sx={{
                            "& td, & th": { borderBottom: "none" },
                          }}
                        >
                          <TableCell
                            className="fw-bold"
                            component="th"
                            scope="row"
                          >
                            <div className="fs-6 fw-bold">Extras Total:</div>
                            <div className="fs-5 fw-bold bluetext">
                              &euro;{(extraTotal || 0).toFixed(2)}
                            </div>
                          </TableCell>
                        </TableRow>
                        <TableRow
                          className="py-1"
                          sx={{
                            "& td, & th": { borderBottom: "none" },
                          }}
                        >
                          <TableCell
                            className="fw-bold"
                            component="th"
                            scope="row"
                          >
                            <div className="fs-6 fw-bold">Total:</div>
                            <div className="fs-5 fw-bold bluetext">
                              &euro;{(bookingExtraTotal || 0).toFixed(2)}(one
                              way)
                            </div>
                          </TableCell>
                        </TableRow>
                      </div>
                      <hr />
                    </div>
                  </div>
                  <div className="col-md-12 heading-section my-">Comments</div>
                  <div className="col-md-12 my-4 m-2">
                    <div class="form-floating">
                      <textarea
                        class="form-control"
                        placeholder="Leave a comment here"
                        id="floatingTextarea"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        maxLength={500}
                      ></textarea>
                      <label for="floatingTextarea">Comments</label>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                        margin: "10px 0",
                      }}
                    >
                      <div
                        style={{
                          flex: "1 1 calc(50% - 10px)",
                          minWidth: "300px",
                          boxSizing: "border-box",
                        }}
                        className="border"
                      >
                        <label className="label-admin-text" htmlFor="address">
                          Extra Options Without Tax
                        </label>
                        <TextField
                          sx={{
                            border: "none",
                            width: "100%",
                            "& .MuiOutlinedInput-root": {
                              "& > fieldset": {
                                border: "none",
                              },
                            },
                          }}
                          value={bookingExtraWithoutTax}
                          className="text-admin"
                          InputProps={{ readOnly: true }}
                        />
                      </div>

                      <div
                        style={{
                          flex: "1 1 calc(50% - 10px)",
                          minWidth: "300px",
                          boxSizing: "border-box",
                        }}
                        className="border"
                      >
                        <label className="label-admin-text" htmlFor="address">
                          Extra Options Tax Amount
                        </label>
                        <TextField
                          sx={{
                            border: "none",
                            width: "100%",
                            "& .MuiOutlinedInput-root": {
                              "& > fieldset": {
                                border: "none",
                              },
                            },
                          }}
                          value={bookingExtraTaxAm}
                          className="text-admin"
                          InputProps={{ readOnly: true }}
                        />
                      </div>

                      <div
                        style={{
                          flex: "1 1 calc(50% - 10px)",
                          minWidth: "300px",
                          boxSizing: "border-box",
                        }}
                        className="border"
                      >
                        <label className="label-admin-text" htmlFor="address">
                          Ride Charges Without Tax
                        </label>
                        <TextField
                          sx={{
                            border: "none",
                            width: "100%",
                            "& .MuiOutlinedInput-root": {
                              "& > fieldset": {
                                border: "none",
                              },
                            },
                          }}
                          value={rideChargesWithoutTax}
                          className="text-admin"
                          InputProps={{ readOnly: true }}
                        />
                      </div>

                      <div
                        style={{
                          flex: "1 1 calc(50% - 10px)",
                          minWidth: "300px",
                          boxSizing: "border-box",
                        }}
                        className="border"
                      >
                        <label className="label-admin-text" htmlFor="address">
                          Tax Amount on Ride Charges
                        </label>
                        <TextField
                          sx={{
                            border: "none",
                            width: "100%",
                            "& .MuiOutlinedInput-root": {
                              "& > fieldset": {
                                border: "none",
                              },
                            },
                          }}
                          value={rideChargesTaxAm}
                          className="text-admin"
                          InputProps={{ readOnly: true }}
                        />
                      </div>

                      <div
                        style={{
                          flex: "1 1 calc(50% - 10px)",
                          minWidth: "300px",
                          boxSizing: "border-box",
                        }}
                        className="border"
                      >
                        <label className="label-admin-text" htmlFor="address">
                          Subtotal Without Tax
                        </label>
                        <TextField
                          sx={{
                            border: "none",
                            width: "100%",
                            "& .MuiOutlinedInput-root": {
                              "& > fieldset": {
                                border: "none",
                              },
                            },
                          }}
                          value={Subtotal}
                          className="text-admin"
                          InputProps={{ readOnly: true }}
                        />
                      </div>

                      <div
                        style={{
                          flex: "1 1 calc(50% - 10px)",
                          minWidth: "300px",
                          boxSizing: "border-box",
                        }}
                        className="border"
                      >
                        <label className="label-admin-text" htmlFor="address">
                          Total Tax
                        </label>
                        <TextField
                          sx={{
                            border: "none",
                            width: "100%",
                            "& .MuiOutlinedInput-root": {
                              "& > fieldset": {
                                border: "none",
                              },
                            },
                          }}
                          value={totalTax}
                          className="text-admin"
                          InputProps={{ readOnly: true }}
                        />
                      </div>
                    </div>
                    <div className="col-md-12 my-2 p-2 border">
                      <label className="label-admin-text" htmlFor="address">
                        Fare (One way fare)
                      </label>
                      <TextField
                        sx={{
                          border: "none",
                          width: "100%",
                          "& .MuiOutlinedInput-root": {
                            "& > fieldset": {
                              border: "none",
                            },
                          },
                        }}
                        type="address"
                        id="address"
                        name="address"
                        value={totalFare}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (/^\d*\.?\d*$/.test(inputValue)) {
                            setFare(inputValue);
                            setErrorDetails((prev) => ({
                              ...prev,
                              fare: "",
                            }));
                          }
                        }}
                        onBlur={() => {
                          if (fare && Number(fare) < bookingExtraTotal) {
                            setErrorDetails((prev) => ({
                              ...prev,
                              fare: `Fare cannot be less than ${bookingExtraTotal}`,
                            }));
                          } else {
                            setErrorDetails((prev) => ({
                              ...prev,
                              fare: "",
                            }));
                          }
                        }}
                        className="text-admin"
                        placeholder="Fare"
                        error={errorDetails.fare}
                        helperText={errorDetails.fare}
                        inputProps={{
                          maxLength: 50,
                          pattern: "[0-9.]*",
                          readOnly: true,
                        }}
                      />
                    </div>
                    {journey === "Return" && (
                      <div className="col-md-12 my-2 p-2 border">
                        <label className="label-admin-text" htmlFor="address">
                          Fare (Return fare)
                        </label>
                        <TextField
                          sx={{
                            border: "none",
                            width: "100%",
                            "& .MuiOutlinedInput-root": {
                              "& > fieldset": {
                                border: "none",
                              },
                            },
                          }}
                          type="address"
                          id="address"
                          name="address"
                          value={totalReturnFare}
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                              setFare(inputValue);
                              setErrorDetails((prev) => ({
                                ...prev,
                                fare: "",
                              }));
                            }
                          }}
                          onBlur={() => {
                            if (fare && Number(fare) < bookingExtraTotal) {
                              setErrorDetails((prev) => ({
                                ...prev,
                                fare: `Fare cannot be less than ${bookingExtraTotal}`,
                              }));
                            } else {
                              setErrorDetails((prev) => ({
                                ...prev,
                                fare: "",
                              }));
                            }
                          }}
                          className="text-admin"
                          placeholder="Fare"
                          error={errorDetails.fare}
                          helperText={errorDetails.fare}
                          inputProps={{
                            maxLength: 50,
                            pattern: "[0-9.]*",
                            readOnly: true,
                          }}
                        />
                      </div>
                    )}
                  </div>
                  {reduxdata?.login?.user?.data?.role === "2" ? (
                    <div className="row">
                      <div className="d-flex flex-wrap gap-4 customPaymentMethodAlignment">
                        <div className="responsiveButtons">
                          <LoadingButton
                            loading={isCashLoading}
                            variant={
                              payType === "Cash" ? "contained" : "outlined"
                            }
                            className="px-xl-5 px-lg-2 px-md-1 responsiveButtons"
                            onClick={() => {
                              callHandleClick("Cash", "pass");
                            }}
                           sx={{
                              height: "calc(100% + 2px)",
                              minHeight: "38px",
                              backgroundColor: isCashLoading
                                ? "#0E4672"
                                : payType === "Cash"
                                ? "#fcbd50"
                                : "transparent",
                              color: isCashLoading
                                ? "#fff"
                                : payType === "Cash"
                                ? "#000"
                                : "inherit",
                              "&:hover": {
                                backgroundColor: isCashLoading
                                  ? "blue"
                                  : "#fcbd50",
                              },
                              "&:active": {
                                backgroundColor: isCashLoading
                                  ? "blue"
                                  : "#e0a63d",
                              },
                            }}
                          >
                            {/* <img
                              src={wallet}
                              width="32px"
                              className="me-2"
                              style={{
                                filter: "invert(100%)",
                              }}
                            /> */}
                            {!isCashLoading && (
                              <img
                                src={wallet}
                                alt="wallet"
                                width="32px"
                                className="me-2"
                                style={{
                                  filter: "invert(100%)",
                                }}
                              />
                            )}
                            Cash
                          </LoadingButton>
                        </div>

                        <div className="responsiveButtons">
                          <LoadingButton
                            loading={isCardLoading}
                            className="px-xl-5 px-lg-2 px-md-1 responsiveButtons"
                            variant="outlined" // Keep outlined since we override the background color manually
                            color="primary"
                            onClick={() => {
                              callHandleClick("Card", "Failed");
                            }}
                            sx={{
                              width: "170px",
                              height: "38px",
                              paddingRight: "2px",
                              paddingLeft: "8px",
                              backgroundColor: paymentCompleted
                                ? "#FFB343"
                                : "transparent", // Change color on payment completion
                              color: paymentCompleted ? "#000" : "inherit", // Ensure text contrast
                              borderColor: paymentCompleted
                                ? "#FFB343"
                                : "rgba(0, 0, 0, 0.23)", // Change border color
                              "&:hover": {
                                backgroundColor: paymentCompleted
                                  ? "#FFA500"
                                  : "#f0f0f0", // Slightly darker yellow on hover
                              },
                            }}
                          >
                            <CreditCardIcon sx={{ mr: 1 }} />
                            Card
                          </LoadingButton>

                          <Modal open={open} onClose={handleClose}>
                            <Box
                              sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                width: "90%",
                                maxWidth: "480px",
                                bgcolor: "background.paper",
                                boxShadow: 24,
                                p: 4,
                                borderRadius: "10px",
                              }}
                            >
                              {clientSecret ? (
                                <Elements
                                  stripe={stripePromise}
                                  options={{ clientSecret }}
                                >
                                  <CheckoutForm
                                    setPayType={setPayType}
                                    handleClose={handleClose}
                                    paymentCompleted={paymentCompleted}
                                    setPaymentCompleted={setPaymentCompleted}
                                    bookingId={id}
                                    // handleClick = {handleClick}
                                  />
                                </Elements>
                              ) : (
                                <Typography textAlign="center">
                                  Loading Payment Options...
                                </Typography>
                              )}
                            </Box>
                          </Modal>
                        </div>

                        <div className="responsiveButtons">
                          <LoadingButton
                          loading={isBankInvoiceLoading}
                            variant={
                              payType === "Bank Invoice"
                                ? "contained"
                                : "outlined"
                            }
                            className="px-xl-5 px-lg-2 px-md-1 responsiveButtons"
                            // onClick={() => {
                            //   callHandleClick("Bank Invoice", "pass");
                            // }}
                            onClick={(e) => {
                                if (limit == null) {
                                  e.preventDefault();
                                  if (!toast.isActive(toastId6)) {
                                    toastId6 = toast.info(
                                      "You cannot use this payment type as its value has not yet been set.",
                                      { autoClose: 2500 }
                                    );
                                  }
                                  return; // stop further execution
                                }

                                // ✅ Only call if limit is not null
                                callHandleClick("Bank Invoice", "pass");
                              }}
                            sx={{
                              width: "170px",
                              height: "38px",
                              paddingRight: "2px",
                              paddingLeft: "8px",
                              backgroundColor: paymentCompleted
                                ? "#FFB343"
                                : "transparent", // Change color on payment completion
                              color: paymentCompleted ? "#000" : "inherit", // Ensure text contrast
                              borderColor: paymentCompleted
                                ? "#FFB343"
                                : "rgba(0, 0, 0, 0.23)", // Change border color
                              "&:hover": {
                                backgroundColor: paymentCompleted
                                  ? "#FFA500"
                                  : "#f0f0f0", // Slightly darker yellow on hover
                              },
                            }}
                          >
                            {!isBankInvoiceLoading && (<ReceiptLongIcon sx={{ mr: 1 }} />)}
                            Bank Invoice
                          </LoadingButton>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="row">
                      <div className="d-flex flex-wrap gap-4 customPaymentMethodAlignment">
                        <div className="responsiveButtons">
                          <Button
                            variant={
                              payType === "Bank Invoice"
                                ? "contained"
                                : "outlined"
                            }
                            className="px-xl-5 px-lg-2 px-md-1 responsiveButtons"
                            onClick={() => {
                              callHandleClick("Bank Invoice", "pass");
                            }}
                            sx={{
                              height: "calc(100% + 2px)",
                              minHeight: "38px",
                              backgroundColor:
                                payType === "Bank Invoice"
                                  ? "#fcbd50"
                                  : "transparent",
                              color:
                                payType === "Bank Invoice" ? "#000" : "inherit",
                              "&:hover": {
                                backgroundColor: "#fcbd50",
                              },
                              "&:active": {
                                backgroundColor: "#e0a63d",
                              },
                            }}
                          >
                            {/* <img
                              src={wallet}
                              width="32px"
                              className="me-2"
                              style={{
                                filter: "invert(100%)",
                              }}
                            /> */}
                            Submit
                          </Button>
                        </div>

                        {/* <div className="responsiveButtons">
                  <BussinessAgentStripePayment
                    amount={parseFloat(total).toFixed(2)}
                    bookingDetails={bookingDetails}
                    showEditModal={showEditModal}
                    fromLocation={fromLocation}
                    toLocation={toLocation}
                    flightNumber={flightNumber}
                    payType={payType}
                    setPayType={setPayType}
                    paymentCompleted={paymentCompleted}
                    setPaymentCompleted={setPaymentCompleted}
                    email={email}
                    onSuccess={(message) => toast.success(message)}
                    onError={(error) => toast.error(error)}
                  />
                </div> */}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </Paper>
          </Box>
        </div>
      </>
    );
}
